import type { DictionaryLanguage, GrammarArcadeEducationalRegion, NewPortalRegion } from '../i18n'
import type { AvatarItemInfo, AvatarItemSlot, UserAvatar, AvatarItemCreateRequest, AvatarItemEditRequest, CombinedAvatarItemType } from '../avatar/avatarItems'
import type { Method, ShowPasswordPromptEvent } from './common'
import { rawRequest, request as libRequest } from './common'
import type { Activity, AddHomeworkOptions, AddRewardGroupInfo, AddSpellingListOptions, AmbiguousUserModel, Bit, CreateChallengeRequest, CurriculumResourceInfo, CustomLeague, CustomLeagueGroup, CustomLeagueUser, EditHomeworkSetRequest, ErrorReportInfo, ExternalCurriculumInfo, ExternalCurriculumNodeInfo, FileUpload, GameSession, HiveGameData, HiveGameInfo, HomeworkData, HomeworkInfo, HomeworkSetInfo, HomeworkUserFilters, LessonEpisodeInfo, LessonEpisodeProgress, LessonEpisodeResponseInfo, LessonInfo, LessonProgress, LessonUserFilters, Locale, NewQuizSessionOptions, NumberGame, PagedResults, Pupil, QuestionSetRatingForUser, QuestionSetUserFilters, QuizActivity, QuizCurriculumInfo, QuizCurriculumNodeAndChildren, QuizCurriculumNodeInfo, QuizPackInfo, QuizQuestionInfo, QuizQuestionSetInfo, QuizSession, QuizSessionInfo, QuizSessionState, QuizSessionSummary, QuizSubjectInfo, QuizSubjectToAdd, ReportedLessonInfo, ReportedQuestionInfo, ResolvedLesson, RewardDataInfo, RewardGroupWithPupilsInfo, RewardPupilAnonymousInfo, RewardPupilInfo, SchoolModel, SortOrderList, SpellingList, StripeInvoiceInfo, SubscriptionUpgradeCostResponse, TableQuery, TeacherHomework, UpdateChallengeRequest, UpdateCompetenceRequest, UpdateCompetenceResponse, UpdateRewardInfo, UserModel, UserRelations, UUID, WritingPiece, WritingPieceLite, RewardPupilEarningsInfo, DictionaryDataToEdit, DictionaryInfo, AddDictionaryRequest, AddUserDictionaryRequest, HomeworkSetCompetenceData, ExternalCurriculumNodeCompetenceInfo, WordToAdd, UserRoles, AddNoteRequest, NoteInfo, EditNoteRequest, NoteTarget, EventLogInfo, GetEventsParams, PhonicsAssessmentInfo, PhonicsGroupComprehensionInfo, GroupInfo, Subscription, Teacher, WondePresyncInfo, WondeExclusionToAdd, WondeExclusionInfo, PhonicsPurchases, PhonicsScreeningQuestion, PhonicsAssessmentType, OneRosterProvider, DecodableBookStructure, PhonicsQuizSessionSummary, SalesEngagementReportFilters, EngagementReportSnapshotInfo, EngagementReportSchoolInfo, EngagementReportSchoolStub, ISO8601Date, PhonicsUserComprehensionInfo, AddPhonicsAssessmentData, AddScreeningAssessmentData, PhonicsWordAssessmentInfo, Sorting, HeadlineSalesRequest, HeadlineSalesResponse, SalesByTypeGraphRequest, SalesByTypeGraphResponse, SpellingListWord, RescheduleSubscriptionResponse, FeaturedQuizQuestionSet, GameSessionUpdateParams, UserStub, MaybePaged, SchoolCreateRequest, SchoolUpdateRequest, SearchListItem, StoreItem, StoreItemFilter, GetMerchStoreItemsFilters, MerchPurchase, AddMerchPurchaseRequest, CloneCurriculumNodeParams, UpdateTestModeGameSessionRequest, ResumeOrCreateTestModeGameSessionRequest, TestModeGameSession, ReportedListInfo, ReportedListWordInfo, ReportListRequestParams, UpdateListOptions, IdOrIdent, GetListsForWordFilters, UpdateWordOptions, DeletedUserInfo, AddMerchProductOptions, CountryInfo, CountryCode, UpdateMerchStockRequest, MerchLocationInfo, CountryZoneInfo, ZoneCode, MerchPurchaseFilters, SubscriptionPermissions, DictionaryFilters, LetterTileToolTrackedWord, EditDraftPurchaseRequest, UserCreateOptions, UpdateGroupRequest, SalesSourceDepts, SalesByPersonResponse, SalesByPersonRequest, SalesByDeptRequest, SalesByDeptResponse, WordsSpelledReportRow, WordsSpelledPerGroupReportRow, ListCompetency, InvoiceFilter, ResourceLinkedNode, UserSettings, EditCountryRequestData, SpellingGameType, StripeEventStub, StripeInvoiceAccountRegion, AddGroupRequest, UpdateAdaptiveSpellingGameSessionRequest, AdaptiveSpellingGameSession, AddSubscriptionProductRequest, SubscriptionProductInfo, EditSubscriptionProductRequest, AddSubscriptionProductScopeRequest, SubscriptionProductScopeInfo, EditSubscriptionProductScopeRequest, SubscriptionPlanInfo, AddSubscriptionPlanRequest, GetSubscriptionPlansFilters, SubscriptionActionInfo, AddPlanActionRequest, GetSubscriptionPlanActionsFilters, EditSubscriptionPlanRequest, StartSubscriptionRequest, StartSubscriptionResponse, StartTrialRequest, GetUpgradeCostParams, UpgradeSubscriptionRequest, UpgradeSubscriptionResponse, SuperuserAddFreeSubscriptionRequest, SubscriptionUpgradeCostRequest, ScheduledUpdateInfo, RescheduleUpdateRequest, NumberGameSession, SimpleSchool, TeacherUpdateRequest, AddTeacherRequest, UpdateAccountRequest, PhonemesInfo, AddPhonemesRequest, EditPhonemesRequest, AdaptiveSpellingUserWord, AdaptiveSpellingUserProgress, AdaptiveSpellingResult, AdaptiveSpellingResultRequest, AddHomeworkSetRequest, HydratedHomeworkSetInfo, ClassLinkTenantInfo, StripeInvoicePaymentMethod, OneRosterOrg, GetSchoolSubscriptionsParams, SuperUserSchoolSearchResult, SuperuserAddBackdatedSubscriptionRequest, SuperuserAddFutureSubscriptionRequest, SuperuserAddTrialSubscriptionRequest, SuperuserAddFullSubscriptionRequest, SuperuserAddSubscriptionResponse, ScheduledSubscriptionInfo, CancelSubRequest, CancelSubscriptionResponse, GetSubscriptionCancellationReasonsFilters, CancellationInfo, TileToolState, CancellationAggregateData, SubscriptionForPlan, GetXeroContactsRequest, XeroContactInfo, SpellingGameInfo, BeekeeperGameInfo, SentencesGameInfo, BuzzwordsGameInfo, Scores, ManualInvoiceToAdd, ConvertSubscriptionRequest, UpdateMiniDiagnosticGameSessionRequest, MiniDiagnosticGameSession, MiniDiagnosticGameSessionOrFinished, MultipartUploadData, MultipartUploadResponse, CloseMultipartUploadRequest, StoredFile, SpellingDiagnosticWord, GetHiveGamesFilters, MergeDeletedUserOptions, UpdateDeletedUserOptions, PupilDiagnosticData, EditSpellingListOptions, GrammarGameIdent, GrammarGameQuestionInfo, GrammarGameQuestionCreateRequest, GrammarGameQuestionEditRequest, QuizTestSessionOptions, HomeworkSessionData, SalesPersonFilters, SalesPerson, ChampionFilters, ChampionModel, AdaptiveSpellingUserLevelHistory, LeagueResultRow, CustomLeagueQuery, SetPoNumberOptions, SpellingHistoryInfo, SpellingHistoryListInfo, MailgunStats, QuestionSetTestsFilters, PupilQuestionSetTestsData, PhonicsScreeningSession, PhonicsScreeningSessionData, GrammarQuestionReport, PupilHomework, GrammarHomeworkSessionData, NonCompliantSubData, NonCompliantSubsFilters, LogGameplayResponse, SaveBeekeeperGameResponse, District, SubscriptionCancellationReason, AddressType, ParentLearnerUpdateOptions, RetentionGraphResponse, GetRetentionEventsRequest, GetRetentionEventsResponse, EditRetentionEventRequest, AddressToAdd, AddressToEdit, AddressInfo, WeeklyGamePlayUserActivity, CreateFeedbackOptions, FeedbackItem, FeedbackQueryOptions, GroupAssignmentBreakdown, TrustedDeviceInfo, AssessmentHistory, UserAssessmentBreakdownItem, GroupMasteryZoneHistoricalLevelItem, GameModePlayCount, MakeSubscriptionPrepaymentRequest, MakeSubscriptionPrepaymentResponse, StartPrepaidSubscriptionRequest, StartPrepaidSubscriptionResponse, UpdateInvoiceRequest, TimesTablesCompetencyData, TimesTablesCompetencyOptions } from './types'
import { Relationship } from './types'
import type { IndyPopSessionToSave } from './types/phonics/session/indy'
import type { PercussionSessionToSave } from './types/phonics/session/percussion'
import type { DareSessionToSave } from './types/phonics/session/dare'
import type { CardMatchSessionToSave } from './types/phonics/session/match'
import type { SoundingOutSessionToSave } from './types/phonics/session/sounding-out'
import type { SceneSoundsSessionToSave } from './types/phonics/session/scene-sounds'
import type { SoundKeyboardSessionToSave } from './types/phonics/session/sound-keyboard'
import type { SoundboardSessionToSave } from './types/phonics/session/soundboard'
import type { CurriculumNodeResourceSortingOption, CurriculumResourceType } from './types/resources'
import type { AvatarModifierType, AvatarPurchaseInfo } from './types/avatar'
import type { GetWritingPiecesRequest } from './types/writing-piece'
import type { GrammarGameQuestionRequest, GrammarGameSessionCreate, GrammarGameSessionFilters, GrammarGameSessionInfo, GrammarGameResponsesForGroup, GrammarGameResponsesForUser, GrammarStage, ReportedGrammarQuestionInfo, GrammarNodesForLinking, CreateGrammarLessonRequest, UpdateGrammarLessonRequest, UpdateGrammarTopicRequest, GrammarCompetenceDataByType, GrammarLessonInfo, GrammarTopicInfo, CreateGrammarTopicRequest } from './types/grammar'
import type { CurriculumProduct } from './types/quiz'
import type { RawD6School } from './types/d6'

export const Api = {
  request: libRequest,

  isInstanced: false,

  token: undefined as string | null | undefined,

  newQueryFormat: false,

  headers: {},

  passwordConfirmationData: undefined as undefined | ShowPasswordPromptEvent,

  withToken (token?: string | null) {
    if (!this.isInstanced) {
      const clone = { ...this }
      clone.isInstanced = true

      return clone.withToken(token)
    }

    if (token === undefined) {
      return Api
    }

    this.token = token

    return { ...this, request: (method: Method, url: string, data: object | null = null, uploadPercentCallback?: (percent: number) => void) => libRequest(method, url, data, uploadPercentCallback, token, this.headers, this.newQueryFormat, this.passwordConfirmationData) }
  },

  useNewQueryFormat () {
    console.log(this.isInstanced)
    if (!this.isInstanced) {
      const clone = { ...this }
      clone.isInstanced = true

      console.log('cloned')

      return clone.useNewQueryFormat()
    }

    this.newQueryFormat = true
    console.log('value set')

    return { ...this, request: (method: Method, url: string, data: object | null = null, uploadPercentCallback?: (percent: number) => void) => libRequest(method, url, data, uploadPercentCallback, this.token, this.headers, true, this.passwordConfirmationData) }
  },

  withHeader (headers: Record<string, string>) {
    if (!this.isInstanced) {
      const clone = { ...this }
      clone.isInstanced = true

      return clone.withHeader(headers)
    }

    this.headers = headers
    return { ...this, request: (method: Method, url: string, data: object | null = null, uploadPercentCallback?: (percent: number) => void) => libRequest(method, url, data, uploadPercentCallback, this.token, headers, this.newQueryFormat, this.passwordConfirmationData) }
  },

  maybePassword (event: ShowPasswordPromptEvent) {
    if (!this.isInstanced) {
      const clone = { ...this }
      clone.isInstanced = true

      return clone.maybePassword(event)
    }

    this.passwordConfirmationData = event
    return { ...this, request: (method: Method, url: string, data: object | null = null, uploadPercentCallback?: (percent: number) => void) => libRequest(method, url, data, uploadPercentCallback, this.token, this.headers, this.newQueryFormat, event) }
  },

  async sendErrorReport (report: ErrorReportInfo): Promise<ErrorReportInfo> {
    const response = await this.request('POST', 'error_report', report)
    return response.data.report
  },

  async consumeAccessToken (accessToken: string): Promise<string> {
    const response = await this.request('GET', `accesstoken?access_token=${accessToken}`)
    return response.data.sessionToken
  },

  async register (details: UserCreateOptions): Promise<UserModel> {
    const response = await this.request('POST', 'users', details)
    return response.data.user
  },

  async registerLearner (details: UserCreateOptions): Promise<{ parent_id: number, child_id: number }> {
    const response = await this.request('POST', 'users/learner', details)
    return response.data
  },

  async forgotPassword (email: string): Promise<boolean> {
    const response = await this.request('POST', 'users/forgot', { email })
    return response.data.success
  },

  async getPasswordResetUser (key: string): Promise<{ username: string, password: string, user_id: number, name: string, email: string }> {
    const response = await this.request('GET', `users/me/passwordreset/${key}`)
    return response.data.data
  },

  async resetPassword (key: string, password: string): Promise<boolean> {
    const response = await this.request('POST', `users/me/passwordreset/${key}`, { password })
    return response.data.success
  },

  async resendVerifyEmail (email: string): Promise<{ success: Bit }> {
    const response = await this.request('POST', '/users/me/sendverifyemail', { email })
    return response.data.success
  },

  async updateParentLearner (details: ParentLearnerUpdateOptions): Promise<UserModel> {
    const response = await this.request('PUT', 'users/parent-learner', details)
    return response.data.user
  },

  async resendParentLearnerEmail (parent_id: number | null, child_id: number | null, username?: string): Promise<boolean> {
    const response = await this.request('POST', '/users/parent-learner/verification-email', { parent_id, child_id, username })
    return response.data.success
  },

  async schoolIdLogin (school_id: number, school_username: string, password: string): Promise<{ user: UserModel, redirect?: string }> {
    const response = await this.request('POST', 'auth/school_id', { school_id, school_username, password })
    return response.data
  },

  async login (username: string, password: string): Promise<{ user: UserModel & { token: string }, redirect?: string }> {
    const response = await this.request('POST', 'auth', { username, password })
    return response.data
  },

  async reverify (password: string): Promise<boolean> {
    const response = await this.request('POST', 'auth/verify-password', { password })
    return response.data.success
  },

  async loginAnon (): Promise<{ user?: UserModel }> {
    const response = await this.request('POST', 'authanon')
    return response.data
  },

  async enableEmailMfa (): Promise<UserModel> {
    const response = await this.request('POST', 'users/me/mfa/email')
    return response.data.user
  },

  async requestAuthenticatorSecret (): Promise<{ otpauth_url: string }> {
    const response = await this.request('GET', 'users/me/mfa/authenticator')
    return response.data
  },

  async confirmAuthenticatorCode (code: number): Promise<{ user: UserModel, backup_codes: string[] }> {
    const response = await this.request('POST', 'users/me/mfa/authenticator', { code })
    return response.data
  },

  async enableUsersEmailMfa (userId: number): Promise<boolean> {
    const response = await this.request('POST', `superuser/users/${userId}/mfa/email`)
    return response.data.success
  },

  async removeUsersAuthenticator (userId: number): Promise<boolean> {
    const response = await this.request('DELETE', `superuser/users/${userId}/mfa/authenticator`)
    return response.data.success
  },

  async removeMyAuthenticator (data: { otp: string } | { code: string }): Promise<UserModel> {
    const response = await this.request('DELETE', 'users/me/mfa/authenticator', data)
    return response.data.user
  },

  async regenerateMyBackupCodes (data: { otp: string } | { code: string }): Promise<string[]> {
    const response = await this.request('PUT', 'users/me/mfa/authenticator/backup', data)
    return response.data.codes
  },

  async disableUsersEmailMfa (userId: number): Promise<boolean> {
    const response = await this.request('DELETE', `superuser/users/${userId}/mfa/email`)
    return response.data.success
  },

  async trustDevice (): Promise<boolean> {
    const response = await this.request('POST', 'users/me/devices')
    return response.data.success
  },

  async getMyTrustedDevices (): Promise<TrustedDeviceInfo['devices']> {
    const response = await this.request('GET', 'users/me/devices')
    return response.data.devices
  },

  async getUsersTrustedDevices (userId: number): Promise<TrustedDeviceInfo['devices']> {
    const response = await this.request('GET', `users/${userId}/devices`)
    return response.data.devices
  },

  async getMyTeachersTrustedDevices (table: TableQuery): Promise<PagedResults<TrustedDeviceInfo>> {
    const response = await this.request('GET', 'users/me/school/teachers/devices', table)
    return response.data.teachers
  },

  async removeTrustedDeviceForUser (userId: number, deviceId: string): Promise<boolean> {
    const response = await this.request('DELETE', `users/${userId}/devices/${deviceId}`)
    return response.data.success
  },

  async removeAllTrustedDevicesForUser (userId: number): Promise<boolean> {
    const response = await this.request('DELETE', `users/${userId}/devices`)
    return response.data.success
  },

  async verifyEmail (code: string, trust: boolean) {
    const response = await this.request('POST', 'users/me/verify', { key: code, trust })
    return response.data
  },

  async verifyByLink (key: string): Promise<UserModel | null> {
    const response = await this.request('POST', 'users/me/verify-link', { key })
    return response.data.user
  },

  async verifyAuthenticator (data: { otp: string } | { code: string }, trust: boolean): Promise<{ user: UserModel, remainingBackupCodes: number | undefined }> {
    const response = await this.request('POST', 'users/me/verify-authenticator', { ...data, trust })
    return response.data
  },

  async verifyChangeOfEmail (key: string): Promise<UserModel | null> {
    const response = await this.request('POST', 'users/me/email-change/verify-link', { key })
    return response.data.user
  },

  async confirmChangeOfEmail (key: string): Promise<UserModel | null> {
    const response = await this.request('POST', 'users/me/email-change/confirm-link', { key })
    return response.data.user
  },

  async denyChangeOfEmail (key: string): Promise<boolean> {
    const response = await this.request('DELETE', 'users/me/email-change/confirm-link', { key })
    return response.data.success
  },

  async authOneRoster (provider: string, code: string, subdomain: string = 'www', redirectUri?: string): Promise<{ user: UserModel, redirect?: string }> {
    const response = await this.request('POST', `one-roster/${provider}/auth`, { code, subdomain, redirectUri })
    return response.data
  },

  async getCurrentUser (): Promise<UserModel> {
    const response = await this.request('GET', 'users/me')
    return response.data.user
  },

  async checkPasswordVerified (): Promise<UserModel> {
    const response = await this.request('GET', 'users/me/password-verified')
    return response.data.user
  },

  async refreshUser (id?: number): Promise<UserModel> {
    if (id) {
      const response = await this.request('POST', `superuser/users/${id}/refresh`)
      return response.data.user
    } else {
      const response = await this.request('GET', 'users/me/refresh')
      return response.data.user
    }
  },

  async getRelationshipBetweenUsers (user: number | string): Promise<Relationship> {
    const response = await this.request('GET', `users/me/users/${user}`)
    const users: UserRelations = response.data.users

    return new Relationship(users)
  },

  async getAvatarPurchases (): Promise<AvatarPurchaseInfo[]> {
    const response = await this.request('GET', 'users/me/avatarpurchases')
    return response.data.items
  },

  async getAvatarPurchasesForUser (username: string): Promise<AvatarPurchaseInfo[]> {
    const response = await this.request('GET', `users/me/school/pupils/${username}/avatarpurchases`)
    return response.data.items
  },

  async updateUser (options: UpdateAccountRequest, emailSentCallback?: (type: string) => void): Promise<UserModel> {
    const response = await this.request('PUT', 'users/me', options)

    if (response.headers['x-email-type-sent'] && emailSentCallback) {
      emailSentCallback(response.headers['x-email-type-sent'])
    }

    return response.data.user
  },

  async saveAvatar (avatar: any): Promise<{ user: UserModel }> {
    const response = await this.request('PUT', 'users/me/avatar', { avatar: JSON.stringify(avatar) })
    return response.data
  },

  async purchaseAvatarItem (type: CombinedAvatarItemType, key: string): Promise<{ items: AvatarPurchaseInfo[], user: UserModel }> {
    const response = await this.request('PUT', 'users/me/avatarpurchases', { type, key })
    return response.data
  },

  async addAvatarModifierForUser (username: string, type: AvatarModifierType, amount: number): Promise<AvatarPurchaseInfo> {
    const response = await this.request('POST', `users/me/school/pupils/${username}/avatarpurchases`, { type, amount })
    return response.data.modifier
  },

  async deleteAvatarPurchaseForUser (id: number, username: string): Promise<AvatarPurchaseInfo> {
    const response = await this.request('DELETE', `users/me/school/pupils/${username}/avatarpurchases/${id}`)
    return response.data
  },

  async getWritingPieces (filter: GetWritingPiecesRequest, tableQuery: TableQuery): Promise<PagedResults<WritingPieceLite>> {
    const response = await this.request('GET', 'writing_pieces/pieces', { ...tableQuery, ...filter })
    return response.data.writing_pieces
  },

  async processWritingPiece (blob: Blob) {
    const response = await this.request('POST', 'writing_pieces/process', blob)
    return response.data
  },

  async loadWritingPiece (id: number) {
    const response = await this.request('GET', `writing_pieces/pieces/${id}`)
    const writingPiece: WritingPiece = response.data.writing_piece
    return writingPiece
  },

  async saveWritingPiece (writingPiece: WritingPiece) {
    const response = await this.request('PUT', 'writing_pieces/pieces', { writing_piece: writingPiece })
    const savedWritingPiece: WritingPiece = response.data.writing_piece
    return savedWritingPiece
  },

  async deleteWritingPiece (id: number) {
    await this.request('DELETE', `writing_pieces/pieces/${id}`)
  },

  async getListDetailed (ident: string, params: { words?: boolean, data_capabilities?: boolean }): Promise<SpellingList> {
    const res = await this.request('GET', `lists/${ident}`, params)
    return res.data.list
  },

  async getListFavouriters (ident: string): Promise<number[]> {
    const res = await this.request('GET', `lists/${ident}/favouriters`)
    return res.data
  },

  async deleteList (ident: string): Promise<{ status: 'Success' }> {
    const res = await this.request('DELETE', `lists/${ident}`)
    return res.data
  },

  async duplicateList (ident: string): Promise<SpellingList> {
    const res = await this.request('POST', `lists/${ident}/duplicate`)
    return res.data.list
  },

  // Superuser only
  async userSearch<T extends TableQuery | undefined> (params: { username?: string, school_id?: number, roles?: UserRoles[] }, table?: T): Promise<MaybePaged<UserStub, T>> {
    const res = await this.request('GET', 'users/search', { ...params, ...table })
    return res.data
  },

  async updateListSU (ident: string, listData: EditSpellingListOptions): Promise<SpellingList> {
    const res = await this.request('PUT', `lists/${ident}`, { ...listData })
    return res.data.list
  },

  async getUserLists (): Promise<SpellingList[]> {
    const res = await this.request('GET', 'users/me/lists')
    return res.data.lists
  },

  async addList (options: AddSpellingListOptions): Promise<SpellingList> {
    const res = await this.request('POST', 'users/me/lists', options)
    return res.data.list
  },

  async editList (ident: string, options: UpdateListOptions): Promise<SpellingList> {
    const res = await this.request('POST', `lists/${ident}`, options)
    return res.data.list
  },

  async getWordsForList<T extends TableQuery | undefined, O extends boolean> (list_ident: string, params: { as_objects: O }, table?: T): Promise<MaybePaged<O extends true ? SpellingListWord : string, T>> {
    const res = await this.request('GET', `lists/${list_ident}/words`, { ...params, ...table })
    return res.data.words
  },

  async deleteWordFromList (list_ident: string, word_ident: string): Promise<SpellingList> {
    const res = await this.request('DELETE', `lists/${list_ident}/words/${word_ident}`)
    return res.data.list
  },

  async updateListWord (options: UpdateWordOptions): Promise<SpellingListWord> {
    const res = await this.request('PUT', `lists/${options.listId}/words/${options.wordId}`, { dictionary_id: options.dictionary_id })
    return res.data.word
  },

  async getWordsForMultipleLists (list_idents: string[]): Promise<{ ident: string, words: SpellingListWord[] }[]> {
    const res = await this.request('GET', 'lists', { lists: list_idents })
    return res.data.words
  },

  async getUserListFavourites (): Promise<SpellingList[]> {
    const res = await this.request('GET', 'users/me/lists/favourites')
    return res.data.lists
  },

  async favouriteList (ident: string): Promise<void> {
    await this.request('PUT', `lists/${ident}/favourite`)
  },

  async unfavouriteList (ident: string): Promise<void> {
    await this.request('DELETE', `lists/${ident}/favourite`)
  },

  async favouriteListForTeacher (list_ident: string, teacher_id: number): Promise<void> {
    await this.request('PUT', `lists/${list_ident}/favourite/teachers/${teacher_id}`)
  },

  async unfavouriteListForTeacher (list_ident: string, teacher_id: number): Promise<void> {
    await this.request('DELETE', `lists/${list_ident}/favourite/teachers/${teacher_id}`)
  },

  async favouriteListForPupil (list_ident: string, pupil_id: number): Promise<void> {
    await this.request('PUT', `lists/${list_ident}/favourite/pupils/${pupil_id}`)
  },

  async unfavouriteListForPupil (list_ident: string, pupil_id: number): Promise<void> {
    await this.request('DELETE', `lists/${list_ident}/favourite/pupils/${pupil_id}`)
  },

  async favouriteListForAllTeachers (list_ident: string): Promise<void> {
    await this.request('PUT', `lists/${list_ident}/favourite/allteachers`)
  },

  async unfavouriteListForAllTeachers (list_ident: string): Promise<void> {
    await this.request('DELETE', `lists/${list_ident}/favourite/allteachers`)
  },

  async favouriteListForGroup (list_ident: string, group_id: number): Promise<void> {
    await this.request('PUT', `lists/${list_ident}/favourite/group/${group_id}`)
  },

  async unfavouriteListForGroup (list_ident: string, group_id: number): Promise<void> {
    await this.request('DELETE', `lists/${list_ident}/favourite/group/${group_id}`)
  },

  async getUserListSchemes (): Promise<SpellingList[]> {
    const res = await this.request('GET', 'users/me/lists/scheme')
    return res.data.lists
  },

  async getListSchemeVariants (locale: Locale): Promise<string[]> {
    const res = await this.request('GET', `lists/schemes/${locale}`)
    return res.data.variants.split(',')
  },

  async getListSchemeVariantLists (locale: Locale, variant: string): Promise<SpellingList[]> {
    const res = await this.request('GET', `lists/schemes/${locale}/${variant}`)
    return res.data.lists
  },

  async getSchemeLists (locale: Locale): Promise<SpellingList[]> {
    const res = await this.request('GET', 'lists/scheme', { locale })
    return res.data.lists
  },

  async getSuggested (locale: Locale): Promise<SpellingList[]> {
    const res = await this.request('GET', 'suggested', { locale })
    return res.data.lists
  },

  async getGroupCompetenceForSchemeListsStage (group: number, stage: number): Promise<ListCompetency[]> {
    const res = await this.request('GET', `users/me/school/groups/${group}/schemecompetence?stage=${stage}`)
    return res.data.lists
  },

  async createList (options: AddSpellingListOptions): Promise<SpellingList> {
    const res = await this.request('POST', 'users/me/lists', { ...options })
    return res.data.list
  },

  async addWordsToList (listIdent: string, words: (string | WordToAdd)[]): Promise<SpellingList> {
    const res = await this.request('POST', `lists/${listIdent}/words`, { words })
    return res.data.list
  },

  async reportList (idOrIdent: IdOrIdent, options: ReportListRequestParams): Promise<ReportedListInfo> {
    const res = await this.request('POST', 'lists/' + (idOrIdent.id || idOrIdent.ident) + '/report', options)
    return res.data.report
  },

  async reportListWord (idOrIdent: IdOrIdent, options: ReportListRequestParams): Promise<ReportedListWordInfo> {
    const res = await this.request('POST', 'lists/words/' + (idOrIdent.id || idOrIdent.ident) + '/report', options)
    return res.data.report
  },

  async getReportedLists (query: TableQuery): Promise<PagedResults<ReportedListInfo>> {
    const res = await this.request('GET', '/lists/reports', { ...query })
    return res.data.results
  },

  async getPupilReportedLists (query: TableQuery): Promise<PagedResults<ReportedListInfo>> {
    const res = await this.request('GET', '/users/me/school/pupils/reported_lists', { ...query })

    const results: PagedResults<ReportedListInfo> = res.data.results

    return results
  },

  async getPupilReportedListWords (query: TableQuery): Promise<PagedResults<ReportedListWordInfo>> {
    const res = await this.request('GET', '/users/me/school/pupils/reported_words', { ...query })
    return res.data.results
  },

  async getPupilReportedLessons (query: TableQuery): Promise<PagedResults<ReportedLessonInfo>> {
    const res = await this.request('GET', '/users/me/school/pupils/reported_lessons', { ...query })
    return res.data.results
  },

  async getPupilReportedLessonEpisodes (query: TableQuery): Promise<PagedResults<ReportedLessonInfo>> {
    const res = await this.request('GET', '/users/me/school/pupils/reported_lesson_episodes', { ...query })
    return res.data.results
  },

  async getPupilReportedQuestionSets (query: TableQuery): Promise<PagedResults<ReportedQuestionInfo>> {
    const res = await this.request('GET', '/users/me/school/pupils/reported_question_sets', { ...query })
    return res.data.results
  },

  async getPupilReportedQuestions (query: TableQuery): Promise<PagedResults<ReportedQuestionInfo>> {
    const res = await this.request('GET', '/users/me/school/pupils/reported_questions', { ...query })
    return res.data.results
  },

  async getReportedListWords (query: TableQuery): Promise<PagedResults<ReportedListWordInfo>> {
    const res = await this.request('GET', '/lists/words/reports', { ...query })
    return res.data.results
  },

  async getUserReportedLists (username: string, query: TableQuery): Promise<PagedResults<ReportedListInfo>> {
    const res = await this.request('GET', `users/${username}/lists`, { ...query })
    return res.data.results
  },

  async getUserReportedListWords (username: string, query: TableQuery): Promise<PagedResults<ReportedListWordInfo>> {
    const res = await this.request('GET', `users/${username}/lists/words`, { ...query })
    return res.data.results
  },

  async closeListReport (id: number) {
    await this.request('PATCH', `lists/reports/${id}`)
  },

  async closeQuestionReport (id: number) {
    await this.request('PATCH', `quiz/reported/${id}/close`)
  },

  async closeGrammarQuestionReport (id: number) {
    await this.request('PATCH', `grammar/questions/reports/${id}/close`)
  },

  async closeLessonReport (id: number) {
    await this.request('PATCH', `lesson/reported/${id}/close`)
  },

  async startSpellingSession (list: string, difficulty: number, gameType: SpellingGameType, phonics: boolean): Promise<GameSession> {
    const res = await this.request('POST', `lists/${list}/gamesession`, { difficulty, gameType, phonics })
    return res.data.session
  },

  async startFreeSpellingSession (list: string): Promise<GameSession> {
    const res = await this.request('POST', `lists/${list}/gamesession`, { difficulty: 4, gameType: 'spelling', freeplay: true })
    return res.data.session
  },

  async logSpellingSession (list: string, params: GameSessionUpdateParams): Promise<LogGameplayResponse> {
    const res = await this.request('POST', `lists/${list}/gameplay`, params)
    return res.data
  },

  async saveBeekeeperSession (list: string, params: GameSessionUpdateParams): Promise<SaveBeekeeperGameResponse> {
    const res = await this.request('POST', `lists/${list}/beekeeper`, params)
    return res.data
  },

  async updateSpellingSession (list: string, session_id: number, params: GameSessionUpdateParams): Promise<LogGameplayResponse> {
    const res = await this.request('PUT', `lists/${list}/gamesession/${session_id}`, params)
    return res.data
  },

  async updateCompetence (options: UpdateCompetenceRequest): Promise<UpdateCompetenceResponse> {
    const res = await this.request('POST', `lists/${options.list_ident}/competency/words`, options)
    return res.data
  },

  async getQuizSessionsForUser (id: number, tableQuery: TableQuery, curriculum?: CurriculumProduct): Promise<PagedResults<QuizSessionSummary>> {
    const res = await this.request('GET', `quiz/session/user/${id}`, { ...tableQuery, curriculum })
    return res.data.sessions
  },

  async updateTestModeGameSession (id: number, options: UpdateTestModeGameSessionRequest): Promise<boolean> {
    const res = await this.request('PUT', `testmodegamesession/${id}`, options)
    return res.data
  },

  async resumeOrCreateTestModeGameSession (list: string, options: ResumeOrCreateTestModeGameSessionRequest): Promise<TestModeGameSession> {
    const res = await this.request('POST', `lists/${list}/testmodegamesession`, options)
    return res.data.session
  },

  async createMiniDiagnosticGameSession (): Promise<MiniDiagnosticGameSession> {
    const res = await this.request('POST', 'adaptive_spelling/minidiagnosticgamesession/')
    return res.data.session
  },

  async updateMiniDiagnosticGameSession (id: number, options: UpdateMiniDiagnosticGameSessionRequest): Promise<MiniDiagnosticGameSessionOrFinished> {
    const res = await this.request('PATCH', `adaptive_spelling/minidiagnosticgamesession/${id}`, options)
    return res.data
  },

  async finishMiniDiagnosticGameSession (id: number): Promise<boolean> {
    const res = await this.request('PATCH', `adaptive_spelling/minidiagnosticgamesession/${id}/finished`)
    return res.data.success
  },

  async createAdaptiveSpellingGameSession (): Promise<AdaptiveSpellingGameSession> {
    const res = await this.request('POST', 'adaptive_spelling/gamesession/')
    return res.data.session
  },

  async updateAdaptiveSpellingGameSession (id: number, options: UpdateAdaptiveSpellingGameSessionRequest): Promise<AdaptiveSpellingGameSession> {
    const res = await this.request('PATCH', `adaptive_spelling/gamesession/${id}`, options)
    return res.data.session
  },

  async finishAdaptiveSpellingSession (id: number): Promise<boolean> {
    const res = await this.request('PATCH', `adaptive_spelling/gamesession/${id}/finished`)
    return res.data.success
  },

  async getMyAdaptiveSpellingWords (): Promise<AdaptiveSpellingUserWord[]> {
    const res = await this.request('GET', 'users/me/adaptive_spelling/words')
    return res.data.words
  },

  async getMyAdaptiveLevelHistory (): Promise<AdaptiveSpellingUserLevelHistory[]> {
    const res = await this.request('GET', 'users/me/adaptive_spelling/level_history')
    return res.data.history
  },

  async getMyAdaptiveSpellingMasteredWords (query: TableQuery): Promise<PagedResults<AdaptiveSpellingUserWord>> {
    const res = await this.request('GET', 'users/me/adaptive_spelling/mastered_words', { ...query })
    return res.data.words
  },

  async getMyAdaptiveSpellingResults (options: AdaptiveSpellingResultRequest): Promise<AdaptiveSpellingResult[]> {
    const res = await this.request('GET', 'users/me/adaptive_spelling/results', options)
    return res.data.results
  },

  async getMyAdaptiveSpellingProgress (): Promise<AdaptiveSpellingUserProgress> {
    const res = await this.request('GET', 'users/me/adaptive_spelling/progress')
    return res.data.progress
  },

  async redeemMyAdaptiveSpellingReward (): Promise<{ success: boolean, user: UserModel }> {
    const res = await this.request('POST', 'users/me/adaptive_spelling/redeem_reward')
    return res.data
  },

  async getPupilsAdaptiveSpellingFocusWords (pupilId: number): Promise<AdaptiveSpellingUserWord[]> {
    const res = await this.request('GET', `users/me/school/pupils/${pupilId}/adaptive_spelling/focus_words`)
    return res.data.words
  },

  async getPupilsAdaptiveSpellingMasteredWords (pupilId: number, query: TableQuery): Promise<PagedResults<AdaptiveSpellingUserWord>> {
    const res = await this.request('GET', `users/me/school/pupils/${pupilId}/adaptive_spelling/mastered_words`, { ...query })
    return res.data.words
  },

  async getPupilsAdaptiveSpellingProgress (pupilId: number, levelDeltaDays?: number): Promise<AdaptiveSpellingUserProgress> {
    const res = await this.request('GET', `users/me/school/pupils/${pupilId}/adaptive_spelling/progress`, { levelDeltaDays })
    return res.data
  },

  async getPupilsAdaptiveSpellingProgressForGroup (groupId: number, levelDeltaDays?: number): Promise<AdaptiveSpellingUserProgress[]> {
    const res = await this.request('GET', `users/me/school/groups/${groupId}/adaptive_spelling/progress`, { levelDeltaDays })
    return res.data
  },

  /** Get a previously played quiz game */
  async getQuizSession (id: UUID): Promise<QuizSessionInfo> {
    const res = await this.request('GET', `quiz/session/${id}`)
    return res.data.session
  },

  /** Create a new (unsaved) quiz game */
  async newQuizSession (options: NewQuizSessionOptions): Promise<QuizSession> {
    const res = await this.request('POST', 'quiz/session', options)
    const session: QuizSession = res.data.session

    // Fill in the `sort_order` property
    for (const q of session.questions) {
      if (q.answers) {
        let i = 0
        for (const a of q.answers) {
          a.sort_order = i
          i += 1
        }

        if (q.type === 'match') {
          let i = 0
          for (const a of q.answers) {
            a.left.sort_order = i
            a.right.sort_order = i
            i += 1
          }
        }
      }
    }

    return session
  },

  async createOrResumeQuizTestSession (options: QuizTestSessionOptions): Promise<QuizSession> {
    const res = await this.request('POST', 'quiz/session/test', options)
    const session: QuizSession = res.data.session

    // Fill in the `sort_order` property
    for (const q of session.questions) {
      if (q.answers) {
        let i = 0
        for (const a of q.answers) {
          a.sort_order = i
          i += 1
        }

        if (q.type === 'match') {
          let i = 0
          for (const a of q.answers) {
            a.left.sort_order = i
            a.right.sort_order = i
            i += 1
          }
        }
      }
    }

    return session
  },

  /** Save a just played quiz game */
  async saveQuizSession (session: QuizSessionState): Promise<{ id: UUID, user: UserModel }> {
    const res = await this.request('PUT', 'quiz/session', { session })
    return res.data
  },

  async manuallyMarkAnswer (answer_id: UUID, correct: Bit, score: number): Promise<void> {
    await this.request('PATCH', 'quiz/session/mark-answer', { answer_id, correct, score })
  },

  // #region External Curricula
  async getExternalCurricula (tableQuery: TableQuery, filters: { published?: boolean }): Promise<PagedResults<ExternalCurriculumInfo>> {
    const res = await this.request('GET', 'quiz/external_curricula', { ...tableQuery, ...filters })
    return res.data.curricula
  },

  async getExternalCurriculum (id: number): Promise<ExternalCurriculumInfo> {
    const res = await this.request('GET', `quiz/external_curricula/${id}`)
    return res.data.curriculum
  },

  async saveExternalCurriculum (curriculum: Partial<ExternalCurriculumInfo>): Promise<ExternalCurriculumInfo> {
    if (curriculum.id) {
      const res = await this.request('PUT', `quiz/external_curricula/${curriculum.id}`, { curriculum })
      return res.data.curriculum
    } else {
      const res = await this.request('POST', 'quiz/external_curricula', { curriculum })
      return res.data.curriculum
    }
  },

  async deleteExternalCurriculum (id: number): Promise<void> {
    await this.request('DELETE', `quiz/external_curricula/${id}`)
  },

  async getAllExternalCurricula (): Promise<ExternalCurriculumInfo[]> {
    const res = await this.request('GET', '/external_curricula/')
    return res.data.curricula
  },

  async getNodesForExternalCurriculum (curriculum_id: number): Promise<ExternalCurriculumNodeInfo[]> {
    const res = await this.request('GET', `/external_curricula/${curriculum_id}/nodes`)
    return res.data.nodes
  },
  // #endregion

  // #region External Curriculum Nodes
  async getExternalCurriculumNodes (query: { curriculum_id?: number, parent_id?: number | null }, tableQuery: TableQuery): Promise<PagedResults<ExternalCurriculumNodeInfo>> {
    const res = await this.request('GET', 'quiz/external_curriculum_nodes', { ...query, ...tableQuery })
    return res.data.nodes
  },

  async getExternalCurriculumNode (id: number): Promise<ExternalCurriculumNodeInfo> {
    const res = await this.request('GET', `quiz/external_curriculum_nodes/${id}`)
    return res.data.node
  },

  async saveExternalCurriculumNode (node: Partial<ExternalCurriculumNodeInfo>): Promise<ExternalCurriculumNodeInfo> {
    if (node.id) {
      const res = await this.request('PUT', `quiz/external_curriculum_nodes/${node.id}`, { node })
      return res.data.node
    } else {
      const res = await this.request('POST', 'quiz/external_curriculum_nodes', { node })
      return res.data.node
    }
  },

  async deleteExternalCurriculumNode (id: number): Promise<void> {
    await this.request('DELETE', `quiz/external_curriculum_nodes/${id}`)
  },
  // #endregion

  // #region Packs
  async getPacks (tableQuery: TableQuery): Promise<PagedResults<QuizPackInfo>> {
    const res = await this.request('GET', 'quiz/packs', { ...tableQuery })
    return res.data.packs
  },

  async getPack (id: number): Promise<QuizPackInfo> {
    const res = await this.request('GET', `quiz/packs/${id}`)
    return res.data.pack
  },

  async savePack (pack: Partial<QuizPackInfo>): Promise<QuizPackInfo> {
    if (pack.id) {
      const res = await this.request('PUT', `quiz/packs/${pack.id}`, { pack })
      return res.data.pack
    } else {
      const res = await this.request('POST', 'quiz/packs', { pack })
      return res.data.pack
    }
  },

  async deletePack (id: number): Promise<void> {
    await this.request('DELETE', `quiz/packs/${id}`)
  },
  // #endregion

  // #region Curricula
  async getCurricula (query: { pack_id?: number }, tableQuery: TableQuery): Promise<PagedResults<QuizCurriculumInfo>> {
    const res = await this.request('GET', 'quiz/curricula', { ...query, ...tableQuery })
    return res.data.curricula
  },

  async getCurriculum (id: number): Promise<QuizCurriculumInfo> {
    const res = await this.request('GET', `quiz/curricula/${id}`)
    return res.data.curriculum
  },

  async saveCurriculum (curriculum: QuizCurriculumInfo): Promise<QuizCurriculumInfo> {
    const data = curriculum.data

    if (data.roots) {
      data.roots = data.roots.filter(r => r.trim() !== '')
    }

    if (data.domains) {
      data.domains = data.domains.filter(r => r.trim() !== '')
    }

    if (curriculum.id) {
      const res = await this.request('PUT', `quiz/curricula/${curriculum.id}`, { curriculum: { ...curriculum, data } })
      return res.data.curriculum
    } else {
      const res = await this.request('POST', 'quiz/curricula', { curriculum: { ...curriculum, data } })
      return res.data.curriculum
    }
  },

  async deleteCurriculum (id: number): Promise<void> {
    await this.request('DELETE', `quiz/curricula/${id}`)
  },
  // #endregion

  // #region Curriculum Nodes
  async getCurriculumNodes (query: { curriculum_id?: number, parent_id?: number | null }, tableQuery: TableQuery): Promise<PagedResults<QuizCurriculumNodeInfo>> {
    const res = await this.request('GET', 'quiz/curriculum_nodes', { ...query, ...tableQuery })
    return res.data.nodes
  },

  async getCurriculumNode (id: number): Promise<QuizCurriculumNodeInfo> {
    const res = await this.request('GET', `quiz/curriculum_nodes/${id}`)
    return res.data.node
  },

  async getCurriculumNodesByUrlPath (url_path: string, sorting: Sorting, curriculum_url_key?: string): Promise<QuizCurriculumNodeAndChildren> {
    const res = await this.request('GET', 'quiz/curriculum_nodes_by_url_path', {
      url_path,
      curriculum_url_key,
      ...sorting
    })
    return res.data.results
  },

  async getCurriculumNodesByTags (tags: { key: string, value: string }[], sorting: Sorting): Promise<readonly QuizCurriculumNodeInfo[]> {
    const res = await this.request('GET', 'quiz/curriculum_nodes_by_tag', { tags: JSON.stringify(tags), ...sorting })
    return res.data
  },

  async saveCurriculumNode (node: QuizCurriculumNodeInfo): Promise<QuizCurriculumNodeInfo> {
    // Remove nulls that will be rejected by the server
    node.resource_ids = node.resource_ids.filter(rid => !!rid)
    node.lesson_ids = node.lesson_ids.filter(rid => !!rid)

    if (node.id) {
      const res = await this.request('PUT', `quiz/curriculum_nodes/${node.id}`, { node })
      return res.data.node
    } else {
      const res = await this.request('POST', 'quiz/curriculum_nodes', { node })
      return res.data.node
    }
  },

  async cloneCurriculumNode (nodeId: number, params: CloneCurriculumNodeParams): Promise<QuizCurriculumNodeInfo> {
    const res = await this.request('POST', `quiz/curriculum_nodes/${nodeId}/clone`, params)
    return res.data.node
  },

  async deleteCurriculumNode (id: number): Promise<void> {
    await this.request('DELETE', `quiz/curriculum_nodes/${id}`)
  },

  async applyCurriculumNodeSortOrders (sortOrders: SortOrderList): Promise<void> {
    await this.request('PATCH', 'quiz/curriculum_nodes/apply_sort_orders', sortOrders)
  },

  async applyCurriculumNodeResourcesOrder (id: number, option: CurriculumNodeResourceSortingOption): Promise<QuizCurriculumNodeInfo> {
    const res = await this.request('PATCH', `quiz/curriculum_nodes/${id}/apply_resources_reorder`, { option })
    return res.data.node
  },
  // #endregion

  // #region Resources
  async getResources (query: TableQuery): Promise<PagedResults<CurriculumResourceInfo>> {
    const res = await this.request('GET', 'resources/resources', { ...query })
    return res.data.resources
  },
  async getResourceTypes (): Promise<CurriculumResourceType[]> {
    const res = await this.request('GET', 'resources/types', null)
    console.log(res)
    return res.data
  },
  async searchResources (curriculum_id: number, query: TableQuery): Promise<PagedResults<Partial<CurriculumResourceInfo>>> {
    const res = await this.request('GET', 'resources/search', { curriculum_id, ...query, search: query.term })
    return res.data.resources
  },

  async getResource (id: number): Promise<CurriculumResourceInfo> {
    const res = await this.request('GET', `resources/resources/${id}`)
    return res.data.resource
  },

  async getResourceByKey (key: string): Promise<CurriculumResourceInfo> {
    const res = await this.request('GET', `resources/resources_by_url_key/${key}`)
    return res.data.resource
  },
  async getResourceByIdent (ident: string): Promise<CurriculumResourceInfo> {
    const res = await this.request('GET', `resources/resources_by_ident/${ident}`)
    return res.data.resource
  },

  async getResourcesLinkedNodes (id: number): Promise<ResourceLinkedNode[]> {
    const res = await this.request('GET', `resources/resources/${id}/nodes`)
    return res.data.nodes
  },

  async generateResourceFileAccessUuid (id: number): Promise<UUID> {
    const res = await this.request('POST', `resources/files/${id}/access_uuid`)
    return res.data.uuid
  },
  // #endregion

  // #region Lessons
  async getLessons (query: TableQuery, filters: LessonUserFilters): Promise<PagedResults<LessonInfo>> {
    const res = await this.request('GET', 'lesson/lessons', { ...query, ...filters })
    return res.data.lessons
  },

  async getPublishedLessons (query: TableQuery, filters: LessonUserFilters): Promise<PagedResults<LessonInfo>> {
    const res = await this.request('GET', 'lesson/lessons', { ...query, view_only_published: true, ...filters })
    return res.data.lessons
  },

  async getMyLessons (query: TableQuery, filters: LessonUserFilters): Promise<PagedResults<LessonInfo>> {
    const res = await this.request('GET', 'users/me/lessons', { ...query, ...filters })
    return res.data.lessons
  },

  async getUsersLessons (username: string, query: TableQuery, filters: LessonUserFilters): Promise<PagedResults<LessonInfo>> {
    const res = await this.request('GET', `/users/${username}/lessons`, { ...query, ...filters })
    return res.data.lessons
  },

  async getMyFavouriteLessons (query: TableQuery): Promise<PagedResults<LessonInfo>> {
    const res = await this.request('GET', '/users/me/lessons/favourites', { ...query })
    return res.data.lessons
  },

  async getLesson (idOrIdent: number | string): Promise<LessonInfo> {
    const res = await this.request('GET', `lesson/lessons/${idOrIdent}`)
    return res.data.lesson
  },

  async getResolvedLesson (idOrIdent: number | string): Promise<ResolvedLesson> {
    const res = await this.request('GET', `lesson/lessons/${idOrIdent}/resolved`)
    return res.data.lesson
  },

  async saveLesson (lesson: Partial<LessonInfo>): Promise<LessonInfo> {
    if (lesson.id) {
      const res = await this.request('PUT', `lesson/lessons/${lesson.id}`, { lesson })
      return res.data.lesson
    } else {
      const res = await this.request('POST', 'lesson/lessons', { lesson })
      return res.data.lesson
    }
  },

  async deleteLesson (id: number): Promise<void> {
    await this.request('DELETE', `lesson/lessons/${id}`)
  },

  async favouriteLesson (id: number): Promise<void> {
    await this.request('PUT', `lesson/lessons/${id}/favourite`, { id })
  },

  async unfavouriteLesson (id: number): Promise<void> {
    await this.request('DELETE', `lesson/lessons/${id}/favourite`, { id })
  },

  async rateLesson (id: number | string, rating: number): Promise<QuestionSetRatingForUser> {
    const res = await this.request('PUT', `lesson/lessons/${id}/rate`, { rating })
    return res.data.ratings
  },

  async reportLesson (idOrIdent: number | string, options: { description: string, type: string }): Promise<ReportedLessonInfo> {
    const res = await this.request('POST', 'lesson/lessons/' + idOrIdent + '/report', options)
    return res.data.report
  },

  async getReportedLessons (query: TableQuery): Promise<PagedResults<ReportedLessonInfo>> {
    const res = await this.request('GET', '/lesson/reported', { ...query })
    return res.data.results
  },
  async getReportedLessonEpisodes (query: TableQuery): Promise<PagedResults<ReportedLessonInfo>> {
    const res = await this.request('GET', '/lesson/reported/episodes', { ...query })
    return res.data.results
  },

  async getUserReportedLessons (username: string, query: TableQuery): Promise<PagedResults<ReportedLessonInfo>> {
    const res = await this.request('GET', `users/${username}/lesson/reported`, { ...query })
    return res.data.results
  },
  async getUserReportedLessonEpisodes (username: string, query: TableQuery): Promise<PagedResults<ReportedLessonInfo>> {
    const res = await this.request('GET', `users/${username}/lesson/reported/episodes`, { ...query })
    return res.data.results
  },
  // #endregion

  // #region Lesson Episodes
  async getLessonEpisodes (lesson_id: number, query: TableQuery): Promise<PagedResults<LessonEpisodeInfo>> {
    const res = await this.request('GET', 'lesson/lesson_episodes', { lesson_id, ...query })
    return res.data.lesson_episodes
  },

  async getLessonEpisode (idOrIdent: number | string): Promise<LessonEpisodeInfo> {
    const res = await this.request('GET', `lesson/lesson_episodes/${idOrIdent}`)
    return res.data.lesson_episode
  },

  async saveLessonEpisode (lesson_episode: Partial<LessonEpisodeInfo>): Promise<LessonEpisodeInfo> {
    if (lesson_episode.id) {
      const res = await this.request('PUT', `lesson/lesson_episodes/${lesson_episode.id}`, { lesson_episode })
      return res.data.lesson_episode
    } else {
      const res = await this.request('POST', 'lesson/lesson_episodes', { lesson_episode })
      return res.data.lesson_episode
    }
  },

  async deleteLessonEpisode (id: number): Promise<void> {
    await this.request('DELETE', `lesson/lesson_episodes/${id}`)
  },
  async deleteLessonEpisodes (ids: string): Promise<void> {
    await this.request('DELETE', 'lesson/lesson_episodes', { ids })
  },

  async applyEpisodeLevels (newLevelPairs: SortOrderList): Promise<void> {
    await this.request('PATCH', 'lesson/lesson_episodes/apply_levels', newLevelPairs)
  },

  async applyEpisodeSortOrders (sortOrders: SortOrderList): Promise<void> {
    await this.request('PATCH', 'lesson/lesson_episodes/apply_sort_orders', sortOrders)
  },

  async moveLessonEpisode (id: number, delta: -1 | 1): Promise<void> {
    await this.request('PATCH', `lesson/lesson_episodes/${id}/move`, { delta })
  },

  async reportLessonEpisode (idOrIdent: number | string, options: { description: string, type: string }): Promise<ReportedLessonInfo> {
    const res = await this.request('POST', 'lesson/lesson_episodes/' + idOrIdent + '/report', options)
    return res.data.report
  },

  /** @deprecated Use `getUserLessonProgress` instead */
  async getUserGamePlaysForLesson (idOrIdent: number | string, username: string): Promise<QuizSessionSummary[]> {
    const res = await this.request('GET', `users/${username}/lessons/${idOrIdent}/game_plays`)
    return res.data.sessions
  },

  /** @deprecated Use `getMyLessonProgress` instead */
  async getMyGamePlaysForLesson (idOrIdent: number | string): Promise<QuizSessionSummary[]> {
    const res = await this.request('GET', `users/me/lessons/${idOrIdent}/game_plays`)
    return res.data.sessions
  },

  async getUserLessonProgress (idOrIdent: number | string, username: string): Promise<LessonProgress> {
    const res = await this.request('GET', `users/${username}/lessons/${idOrIdent}/progress`)
    return res.data.sessions
  },

  async getMyLessonProgress (idOrIdent: number | string): Promise<LessonProgress> {
    const res = await this.request('GET', `users/me/lessons/${idOrIdent}/progress`)
    return res.data.sessions
  },

  async getUserLessonEpisodeProgress (idOrIdent: number | string, username: string): Promise<LessonEpisodeProgress> {
    const res = await this.request('GET', `users/${username}/lesson_episodes/${idOrIdent}/progress`)
    return res.data.sessions
  },

  async getMyLessonEpisodeProgress (idOrIdent: number | string): Promise<LessonEpisodeProgress> {
    const res = await this.request('GET', `users/me/lesson_episodes/${idOrIdent}/progress`)
    return res.data.sessions
  },

  async getLessonEpisodeResponse (id: number): Promise<LessonEpisodeResponseInfo> {
    const res = await this.request('GET', `lesson/lesson_episode_responses/${id}`)
    return res.data.lesson_episode_response
  },

  async saveLessonEpisodeResponse (lesson_episode_response: Partial<LessonEpisodeResponseInfo>): Promise<LessonEpisodeResponseInfo> {
    if (lesson_episode_response.id) {
      const res = await this.request('PUT', `lesson/lesson_episode_responses/${lesson_episode_response.id}`, { lesson_episode_response })
      return res.data.lesson_episode_response
    } else {
      const res = await this.request('POST', 'lesson/lesson_episode_responses', { lesson_episode_response })
      return res.data.lesson_episode_response
    }
  },

  async deleteLessonEpisodeResponse (id: number): Promise<void> {
    await this.request('DELETE', `lesson/lesson_episode_responses/${id}`)
  },

  async saveNumberSession (data: NumberGameSession): Promise<{ user: UserModel, session?: NumberGame }> {
    const res = await this.request('PUT', 'number/gamesession', { data })
    return res.data
  },

  // #endregion

  // #region Question Sets
  /** @param parent_id NOTE: `null` = No parent, `undefined` = Ignore parent */
  async getQuestionSets (parent_id: number | null | undefined, query: TableQuery, filters: QuestionSetUserFilters): Promise<PagedResults<QuizQuestionSetInfo>> {
    const res = await this.request('GET', 'quiz/question_sets', { ...query, parent_id, respect_permissions: true, ...filters })
    return res.data.sets
  },

  async getQuestionSetsByExternalCurriculumId (externalCurriculumId: number): Promise<QuizQuestionSetInfo[]> {
    const res = await this.request('GET', `quiz/question_sets/external_curricula/${externalCurriculumId}`)
    return res.data.sets
  },

  async getAllQuestionSets (parent_id: number | null | undefined, query: TableQuery, filters: QuestionSetUserFilters): Promise<PagedResults<QuizQuestionSetInfo>> {
    const res = await this.request('GET', 'quiz/question_sets', { ...query, parent_id, ...filters })
    return res.data.sets
  },

  async getPublishedQuestionSets (parent_id: number | null | undefined, query: TableQuery, filters: QuestionSetUserFilters): Promise<PagedResults<QuizQuestionSetInfo>> {
    const res = await this.request('GET', 'quiz/question_sets', { ...query, parent_id, view_only_published: true, ...filters })
    return res.data.sets
  },

  async getMyQuestionSets (parent_id: number | null | undefined, query: TableQuery, filters: QuestionSetUserFilters): Promise<PagedResults<QuizQuestionSetInfo>> {
    const res = await this.request('GET', '/users/me/question_sets', { ...query, parent_id, ...filters })
    return res.data.sets
  },

  async getUsersQuestionSets (username: string, query: TableQuery, filters: QuestionSetUserFilters): Promise<PagedResults<QuizQuestionSetInfo>> {
    const res = await this.request('GET', `/users/${username}/question_sets`, { ...query, ...filters, respect_permissions: true })
    return res.data.sets
  },

  async getGroupsDraftQuestionSets (group_id: number, query: TableQuery, filters: QuestionSetUserFilters): Promise<PagedResults<QuizQuestionSetInfo>> {
    const res = await this.request('GET', `/users/me/school/groups/${group_id}/draft_question_sets`, { ...query, ...filters, respect_permissions: true })
    return res.data.sets
  },

  async getQuestionSet (id: number | string): Promise<QuizQuestionSetInfo> {
    const res = await this.request('GET', `quiz/question_sets/${id}`)
    return res.data.set
  },

  async saveQuestionSet (set: Partial<QuizQuestionSetInfo>): Promise<QuizQuestionSetInfo> {
    if (set.id) {
      const res = await this.request('PUT', `quiz/question_sets/${set.id}`, { set })
      return res.data.set
    } else {
      const res = await this.request('POST', 'quiz/question_sets', { set })
      return res.data.set
    }
  },

  async startQuestionSetVideoUpload (data: MultipartUploadData): Promise<MultipartUploadResponse> {
    const res = await this.request('POST', 'quiz/question_sets/video_upload', data)
    return res.data
  },

  async closeQuestionSetVideoUpload (uploadId: string, data: CloseMultipartUploadRequest): Promise<StoredFile> {
    const res = await this.request('DELETE', `quiz/question_sets/video_upload/${uploadId}`, data)
    return res.data.file
  },

  async deleteQuestionSet (id: number): Promise<void> {
    await this.request('DELETE', `quiz/question_sets/${id}`)
  },

  async cloneQuestionSet (id: number | string, name?: string): Promise<QuizQuestionSetInfo> {
    const res = await this.request('POST', `quiz/question_sets/${id}/clone`, { name })
    return res.data.set
  },

  async favouriteQuestionSet (id: number): Promise<void> {
    await this.request('PUT', `quiz/question_sets/${id}/favourite`, { id })
  },

  async unfavouriteQuestionSet (id: number): Promise<void> {
    await this.request('DELETE', `quiz/question_sets/${id}/favourite`, { id })
  },

  async getMyFavouriteQuestionSets (query: TableQuery): Promise<PagedResults<QuizQuestionSetInfo>> {
    const res = await this.request('GET', 'users/me/quiz/question_sets/favourites', { ...query })
    return res.data.question_sets
  },

  async getTrendingQuestionSets (params: { locale?: DictionaryLanguage }): Promise<QuizQuestionSetInfo[]> {
    const res = await this.request('GET', 'quiz/question_sets/trending', params)
    return res.data.question_sets
  },

  async getFeaturedQuestionSets (params: { locale?: DictionaryLanguage }): Promise<FeaturedQuizQuestionSet[]> {
    const res = await this.request('GET', 'superuser/featured_quiz_question_sets', params)
    return res.data.question_sets
  },

  async addFeaturedQuestionSet (params: { quiz_ident: string, locale: DictionaryLanguage }): Promise<FeaturedQuizQuestionSet> {
    const res = await this.request('POST', 'superuser/featured_quiz_question_sets', params)
    return res.data.question_set
  },

  async deleteFeaturedQuestionSet (id: number): Promise<void> {
    await this.request('DELETE', `superuser/featured_quiz_question_set/${id}`)
  },

  async getFeaturedQuestionSetInfos (params: { locale?: DictionaryLanguage }): Promise<QuizQuestionSetInfo[]> {
    const res = await this.request('GET', 'quiz/question_sets/featured', params)
    return res.data.question_sets
  },

  async applyFeaturedQuizzesSortOrders (sortOrders: SortOrderList): Promise<void> {
    await this.request('PATCH', 'superuser/featured_quiz_question_sets/sort_orders', sortOrders)
  },

  async getRecentQuestionSets (): Promise<QuizQuestionSetInfo[]> {
    const res = await this.request('GET', 'users/me/quiz/question_sets/recent', null)
    return res.data.question_sets
  },

  async getQuestionSetRatingsData (id: number | string): Promise<QuestionSetRatingForUser> {
    const res = await this.request('GET', `quiz/question_sets/${id}/rate`, null)
    return res.data.ratings
  },

  async rateQuestionSet (id: number | string, rating: number): Promise<QuestionSetRatingForUser> {
    const res = await this.request('PUT', `quiz/question_sets/${id}/rate`, { rating })
    return res.data.ratings
  },

  async reportQuestionSet (idOrIdent: number | string, options: { description: string, type: string }): Promise<ReportedQuestionInfo> {
    const res = await this.request('POST', 'quiz/question_sets/' + idOrIdent + '/report', options)
    return res.data.report
  },

  async getReportedQuestions (query: TableQuery): Promise<PagedResults<ReportedQuestionInfo>> {
    const res = await this.request('GET', '/quiz/reported/questions', { ...query })
    return res.data.results
  },
  async getReportedQuestionSets (query: TableQuery): Promise<PagedResults<ReportedQuestionInfo>> {
    const res = await this.request('GET', '/quiz/reported', { ...query })
    return res.data.results
  },

  async getUserReportedQuestions (username: string, query: TableQuery): Promise<PagedResults<ReportedQuestionInfo>> {
    const res = await this.request('GET', `users/${username}/quiz/reported/questions`, { ...query })
    return res.data.results
  },
  async getUserReportedQuestionSets (username: string, query: TableQuery): Promise<PagedResults<ReportedQuestionInfo>> {
    const res = await this.request('GET', `users/${username}/quiz/reported`, { ...query })
    return res.data.results
  },

  async getQuizSubjects (): Promise<QuizSubjectInfo[]> {
    const res = await this.request('GET', 'quiz/subjects', {})
    return res.data.subjects
  },

  async addQuizSubject (data: QuizSubjectToAdd): Promise<QuizSubjectInfo> {
    const res = await this.request('POST', 'quiz/subjects', data)
    return res.data.subject
  },

  async deleteQuizSubject (id: number): Promise<boolean> {
    const res = await this.request('DELETE', `quiz/subjects/${id}`, {})
    return res.data.success
  },

  async editQuizSubject (id: number, data: QuizSubjectToAdd): Promise<QuizSubjectInfo> {
    const res = await this.request('PUT', `quiz/subjects/${id}`, data)
    return res.data.subject
  },
  // #endregion

  // #region Question
  async getQuestions (set_id: number | null | undefined, query: TableQuery): Promise<PagedResults<QuizQuestionInfo>> {
    const res = await this.request('GET', 'quiz/questions', { ...query, set_id })
    return res.data.questions
  },

  async getQuestion (id: number): Promise<QuizQuestionInfo> {
    const res = await this.request('GET', `quiz/questions/${id}`)
    return res.data.question
  },

  async saveQuestion (question: Partial<QuizQuestionInfo>): Promise<QuizQuestionInfo> {
    if (question.id) {
      const res = await this.request('PUT', `quiz/questions/${question.id}`, { question })
      return res.data.question
    } else {
      const res = await this.request('POST', 'quiz/questions', { question })
      return res.data.question
    }
  },

  async deleteQuestion (id: number): Promise<void> {
    await this.request('DELETE', `quiz/questions/${id}`)
  },

  async deleteQuestions (ids: number[]): Promise<void> {
    await this.request('DELETE', 'quiz/questions', { ids })
  },

  async moveQuestion (id: number, delta: -1 | 1): Promise<void> {
    await this.request('PATCH', `quiz/questions/${id}/move`, { delta })
  },

  async applyQuestionSortOrders (sortOrders: SortOrderList): Promise<void> {
    await this.request('PATCH', 'quiz/questions/apply_sort_orders', sortOrders)
  },

  async reportQuestion (id: number, options: { description: string, type: string }): Promise<ReportedQuestionInfo> {
    const res = await this.request('POST', 'quiz/questions/' + id + '/report', options)
    return res.data.report
  },
  // #endregion

  // #region Schools
  async addSchool (school: SchoolCreateRequest): Promise<UserModel> {
    const res = await this.request('POST', 'users/me/school', school)
    return res.data.user
  },
  async joinSchool (code: string): Promise<UserModel> {
    const res = await this.request('POST', 'users/me/joinschool', { code })
    return res.data.user
  },
  async getSchool (id: number): Promise<SchoolModel> {
    const res = await this.request('GET', `schools/${id}`)
    return res.data.school
  },
  async updateSchool (school: SchoolUpdateRequest): Promise<UserModel> {
    const res = await this.request('PUT', 'users/me/school', school)
    return res.data.user
  },
  async suUpdateSchool (id: number, update: SchoolUpdateRequest): Promise<SchoolModel> {
    const res = await this.request('PATCH', `schools/${id}`, update)
    return res.data.school
  },
  async getMySchools (): Promise<SchoolModel[]> {
    const res = await this.request('GET', 'users/me/schools')
    return res.data.schools
  },
  async getMyPaymentMethods (): Promise<{ payment_methods: any[], default_payment_method?: string | null }> { // type is Stripe.PaymentMethod, but using any to avoid forced dependency
    const res = await this.request('GET', 'users/me/school/paymentmethods')
    return res.data
  },
  async savePaymentMethod<Ret extends boolean> (pmId: string, verify: Ret = false as Ret): Promise<Ret extends false ? boolean : object> { // real type is Stripe.SetupIntent
    const res = await this.request('POST', 'users/me/school/paymentmethods', { verify, paymentMethod: pmId })

    if (res.data.success === true) {
      return res.data.success
    } else {
      return res.data.intent
    }
  },
  async deletePaymentMethod (pmId: string): Promise<object> { // real return type is Stripe.PaymentMethod
    const res = await this.request('DELETE', `users/me/school/paymentmethods/${pmId}`)
    return res.data.paymentMethod
  },
  async payStripeInvoice (id: string, data: { payment_method_id: string }): Promise<{ intent_secret: string | null, subscription: Subscription | null, user: UserModel }> {
    const res = await this.request('POST', `users/me/school/invoices/${id}/pay`, data)
    return res.data
  },
  async payMerchInvoice (id: number, data: { payment_method_id: string }): Promise<{ payment_intent_id: string, client_secret: string | null }> {
    const res = await this.request('POST', `store/purchases/${id}/pay`, data)
    return res.data
  },
  async getD6Schools (): Promise<{ schools: RawD6School[] }> {
    const res = await this.request('GET', 'd6/schools')
    return res.data
  },
  async getD6SchoolData (d6Id: number): Promise<{ schools: RawD6School[] }> {
    const res = await this.request('GET', 'd6/schools/' + d6Id)
    return res.data
  },

  async d6ActivateSchool (d6Id: number): Promise<boolean> {
    const res = await this.request('POST', 'd6/schools/' + d6Id + '/activation')
    return res.data.success
  },
  async d6DeactivateSchool (d6Id: number): Promise<boolean> {
    const res = await this.request('DELETE', 'd6/schools/' + d6Id + '/activation')
    return res.data.success
  },
  async connectD6 (): Promise<boolean> {
    const res = await this.request('POST', 'users/me/school/d6/request')
    return res.data.success
  },
  async linkD6 (schoolId: number, d6Id: number): Promise<boolean> {
    const res = await this.request('POST', `schools/${schoolId}/setd6id`, { d6_id: d6Id })
    return res.data.success
  },
  async unlinkD6 (schoolId: number): Promise<boolean> {
    const res = await this.request('DELETE', `schools/${schoolId}/setd6id`)
    return res.data.success
  },
  async d6Sync (d6Id: number): Promise<{ success: boolean, syncing: boolean }> {
    const res = await this.request('POST', `d6/schools/${d6Id}/sync`)
    return { success: res.data.success, syncing: res.data.syncing }
  },
  async switchSchool (schoolId: number): Promise<UserModel> {
    const res = await this.request('POST', 'users/me/manageschool', { schoolId })
    return res.data.user
  },
  // #endregion

  // #region Pupils
  async getPupils (school_username?: string): Promise<Pupil[]> {
    const res = await this.request('GET', 'users/me/school/pupils', { school_username })
    return res.data.pupils
  },
  async getPupil (username: string): Promise<Pupil> {
    const res = await this.request('GET', `users/me/school/pupils/${username}`)
    return res.data.pupil
  },
  async getPupilsSpellingGameHistory (username: string): Promise<SpellingGameInfo[]> {
    const res = await this.request('GET', `users/me/school/pupils/${username}/history`)
    return res.data.data
  },
  async getGroupSpellingGamePlayTypeHistory (groupId: number, params: { stage?: number, from?: ISO8601Date, to?: ISO8601Date }): Promise<GameModePlayCount[]> {
    const res = await this.request('GET', `users/me/school/groups/${groupId}/game_play_type_history`, params)
    return res.data
  },
  async getGroupGrammarArcadePlays (groupId: number, stage: number, from: ISO8601Date, to: ISO8601Date): Promise<number[]> {
    const res = await this.request('GET', `/users/me/school/groups/${groupId}/grammar/plays`, { stage, from, to })
    return res.data
  },
  async getPupilsSentenceGameHistory (username: string): Promise<SentencesGameInfo[]> {
    const res = await this.request('GET', `users/me/school/pupils/${username}/history`)
    return res.data.data
  },
  async getPupilsBeekeeperGameHistory (username: string): Promise<BeekeeperGameInfo[]> {
    const res = await this.request('GET', `users/me/school/pupils/${username}/beekeeperhistory`)
    return res.data.data
  },
  async getPupilsBuzzwordsGameHistory (username: string): Promise<BuzzwordsGameInfo[]> {
    const res = await this.request('GET', `users/me/school/pupils/${username}/buzzwordshistory`)
    return res.data.data
  },
  async getPupilMathsHistoryData (username: string, key?: string): Promise<NumberGame[]> {
    const res = await this.request('GET', `users/me/school/pupils/${username}/mathshistory`, { key })
    return res.data.data
  },
  async getTimesTablesCompetencyData (params: TimesTablesCompetencyOptions): Promise<TimesTablesCompetencyData[]> {
    const res = await this.request('GET', 'users/me/school/pupils/timestablescompetency', params)
    return res.data.data
  },
  async getListsPlayedByGroup (groupId: number, params: { from?: number, to?: number }): Promise<SpellingHistoryListInfo[]> {
    const res = await this.request('GET', `users/me/school/groups/${groupId}/history/lists`, params)
    return res.data.lists
  },
  async getGroupSpellingHistory (groupId: number, params: { from?: number, to?: number, list_id?: number }): Promise<SpellingHistoryInfo[] | null> {
    const res = await this.request('GET', `users/me/school/groups/${groupId}/history`, params)
    return res.data.history
  },
  async getGroupSpellingAverageTermlyProgression (groupId: number, stage: number): Promise<AssessmentHistory[]> {
    const res = await this.request('GET', `users/me/school/groups/${groupId}/spelling/termly_progression`, { stage })
    return res.data
  },
  async getGroupsSpellingHistoricalMasteryZoneLevels (groupId: number): Promise<GroupMasteryZoneHistoricalLevelItem[]> {
    const res = await this.request('GET', `/users/me/school/groups/${groupId}/adaptive_spelling/historical_levels`)
    return res.data
  },
  async getGroupMathsHistory (groupId: number, key: string): Promise<NumberGame[]> {
    const res = await this.request('GET', `users/me/school/groups/${groupId}/mathshistory/${key}`)
    return res.data.history
  },
  async downloadPupils (pupilIds?: number[]): Promise<string> {
    const res = await this.request('GET', 'users/me/school/pupils/csv', { pupilIds })
    return res.data.data
  },
  async getRandomDisplayName (): Promise<string> {
    const res = await this.request('GET', 'users/displayname')
    return res.data.displayName
  },
  async getRandomDisplayNames (amount: number): Promise<string[]> {
    const res = await this.request('GET', 'users/displayname', { amount })
    return res.data.displayNames
  },
  /** @deprecated Return type cannot be trusted!!! Call `getPupilsInGroup` for refreshed information */
  async updatePupils (pupils: AmbiguousUserModel[]): Promise<Pupil[]> {
    const res = await this.request('PUT', 'users/me/school/pupils', { pupils })
    return res.data.pupils
  },
  async updatePupil (username: string, payload: {}): Promise<Pupil> {
    const res = await this.request('PUT', `users/me/school/pupils/${username}`, payload)
    return res.data.pupil
  },
  async addPupil (payload: Partial<UserModel>): Promise<Pupil[]> {
    const res = await this.request('POST', 'users/me/school/pupils', payload)
    return res.data.pupils
  },
  async generateTestPupils (amount: number): Promise<Pupil[]> {
    const res = await this.request('POST', 'users/me/school/pupils/generate', { amount })
    return res.data.pupils
  },
  async deletePupils (pupils: number[]): Promise<Pupil[]> {
    const res = await this.request('DELETE', 'users/me/school/pupils', { pupils: pupils.join() })
    return res.data.pupils
  },
  async deleteAllPupils (): Promise<any> {
    const res = await this.request('DELETE', 'users/me/school/pupils', { pupils: '*' })
    return res.data
  },
  async deleteNumberGameplay (username: string, gameplayId: number): Promise<NumberGame> {
    const res = await this.request('DELETE', `users/me/school/pupils/${username}/mathshistory/${gameplayId}`)
    return res.data.session
  },
  async usernameExists (username: string): Promise<boolean> {
    const res = await this.request('GET', 'users/exists', { username })
    return res.data.exists
  },
  async generateUsername (name: string): Promise<string> {
    const res = await this.request('GET', 'users/generate', { name })
    return res.data.username
  },
  async emailExists (email: string): Promise<boolean> {
    const res = await this.request('GET', 'users/exists', { email })
    return res.data.exists
  },
  async schoolUsernameExists (school_username: string): Promise<boolean> {
    const res = await this.request('GET', 'users/exists', { school_username })
    return res.data.exists
  },
  async cleverSync (clever_oid: string): Promise<any> {
    const res = await this.request('POST', `schools/${clever_oid}/cleversync`)
    return res
  },
  async wondeSync (wonde_id: string): Promise<any> {
    const res = await this.request('POST', `schools/${wonde_id}/wondesync`)
    return res
  },
  async wondeAuth (code: string, subdomain: string): Promise<UserModel> {
    const res = await this.request('POST', 'wonde/auth', { code, subdomain })
    return res.data.user
  },
  async myLoginAuth (code: string, subdomain: string): Promise<any> {
    const res = await this.request('POST', 'mylogin/auth', { code, subdomain })
    return res
  },
  async snapplifyAuth (code: string, domain: string): Promise<any> {
    const res = await this.request('POST', 'snapplify/auth', { code, domain })
    return res
  },
  async wondePreSync (wonde_id: string): Promise<WondePresyncInfo> {
    const res = await this.request('GET', `schools/${wonde_id}/wondepresync`)
    return res.data
  },
  async checkWondeSyncFlag (wonde_id: string): Promise<boolean> {
    const res = await this.request('GET', `wonde/schools/${wonde_id}/sync`)
    return res.data
  },
  async linkWonde (): Promise<any> {
    const res = await this.request('POST', 'users/me/school/linkwonde')
    return res
  },
  async unlinkWonde (schoolId: number): Promise<boolean> {
    const res = await this.request('DELETE', `schools/${schoolId}/setwondeid`)
    return res.data.success
  },
  async getWondeExclusions (wondeId: string): Promise<WondeExclusionInfo[]> {
    const res = await this.request('GET', `wonde/school/${wondeId}/exclusions`)
    return res.data
  },
  async addWondeExclusions (wondeId: string, exclusions: WondeExclusionToAdd[], deleteExclusions: boolean): Promise<WondeExclusionInfo[]> {
    const res = await this.request('POST', `wonde/school/${wondeId}/exclusions`, { exclusions, delete: deleteExclusions })
    return res.data
  },
  async removeWondeExclusions (wondeId: string, idsToDelete: number[]): Promise<WondeExclusionInfo[]> {
    const res = await this.request('DELETE', `wonde/school/${wondeId}/exclusions`, { ids: idsToDelete })
    return res.data
  },
  async linkClever (): Promise<any> {
    const res = await this.request('POST', 'users/me/school/linkclever')
    return res
  },
  async linkGG4L (): Promise<boolean> {
    const res = await this.request('POST', 'users/me/school/linkGG4L')
    return res.data.success
  },
  async linkClassLink (): Promise<boolean> {
    const res = await this.request('POST', 'users/me/school/linkClassLink')
    return res.data.success
  },
  async incrementAllPupilStages (): Promise<any> {
    const res = await this.request('POST', '/users/me/school/incrementstages')
    return res
  },
  async setSettings (settings: Partial<UserSettings>): Promise<UserSettings> {
    const res = await this.request('PATCH', 'users/me/settings', settings)
    return res.data.settings
  },
  // #endregion
  // #region Groups
  async addGroup (group: AddGroupRequest): Promise<GroupInfo> {
    const res = await this.request('POST', 'users/me/school/groups', group)
    return res.data.group
  },
  async addTeachersToGroup (groupId: number, teacherIds: number[]): Promise<Teacher[]> {
    const res = await this.request('PUT', `users/me/school/groups/${groupId}/teachers`, { teachers: teacherIds })
    return res.data.teachers
  },
  async removeTeacherFromGroup (groupId: number, teacherId: number): Promise<Teacher> {
    const res = await this.request('DELETE', `users/me/school/groups/${groupId}/teachers`, { teacherId })
    return res.data.teacher
  },
  async updateGroup (groupId: number, payload: UpdateGroupRequest): Promise<GroupInfo> {
    const res = await this.request('PUT', `users/me/school/groups/${groupId}`, payload)
    return res.data.group
  },
  async getGroup (groupId: number): Promise<GroupInfo> {
    const res = await this.request('GET', `users/me/school/groups/${groupId}`)
    return res.data.group
  },
  async getMyGroups (includeSubgroups?: boolean): Promise<GroupInfo[]> {
    const res = await this.request('GET', 'users/me/groups', { includeSubgroups })
    return res.data.groups
  },
  async getGroups (includeSubgroups?: boolean): Promise<GroupInfo[]> {
    const res = await this.request('GET', 'users/me/school/groups', { includeSubgroups })
    return res.data.groups
  },
  async getAllGroups (includeSubgroups?: boolean, predictStage?: boolean): Promise<GroupInfo[]> {
    const res = await this.request('GET', 'users/me/school/groups/all', { includeSubgroups, predictStage })
    return res.data.groups
  },
  async getGroupActivity (groupId: number): Promise<Activity[]> {
    const res = await this.request('GET', `users/me/school/groups/${groupId}/activity`)
    return res.data.activity
  },
  async getGroupWeeklySpellingPlayUsers (groupId: number, stage: number): Promise<WeeklyGamePlayUserActivity> {
    const res = await this.request('GET', `/users/me/school/groups/${groupId}/spelling_plays`, { stage })
    return res.data
  },
  async getGroupWeeklySpellingMasteryZonePlayUsers (groupId: number): Promise<WeeklyGamePlayUserActivity> {
    const res = await this.request('GET', `/users/me/school/groups/${groupId}/mastery_zone_plays`)
    return res.data
  },
  async getGroupMathsActivity (groupId: number): Promise<Activity[]> {
    const res = await this.request('GET', `users/me/school/groups/${groupId}/activitymaths`)
    return res.data.activity
  },
  async getGroupQuizActivity (groupId: number): Promise<QuizActivity[]> {
    const res = await this.request('GET', `users/me/school/groups/${groupId}/activityquiz`)
    return res.data.activity
  },
  async assignToGroup (groupId: number, pupils: number[]): Promise<Pupil[]> {
    const res = await this.request('POST', `users/me/school/groups/${groupId}/pupils`, { pupils, move: 0 })
    return res.data.pupils
  },
  async moveToGroup (groupId: number, pupils: number[]): Promise<Pupil[]> {
    const res = await this.request('POST', `users/me/school/groups/${groupId}/pupils`, { pupils, move: 1 })
    return res.data.pupils
  },
  async removePupilFromGroup (groupId: number, pupilId: number): Promise<Pupil> {
    const res = await this.request('DELETE', `users/me/school/groups/${groupId}/pupils`, { pupilId })
    return res.data.pupil
  },
  async removeAllPupilsFromAllGroups (): Promise<boolean> {
    const success = await this.removePupilsFromGroups('*', '*')
    return success
  },
  async deleteGroup (groupId: number): Promise<GroupInfo> {
    const res = await this.request('DELETE', `users/me/school/groups/${groupId}`)
    return res.data.group
  },
  async deleteAllGroups (): Promise<void> {
    const res = await this.request('DELETE', 'users/me/school/groups')
    return res.data.groups
  },
  async getPupilsInGroup (groupId: number): Promise<Pupil[]> {
    const res = await this.request('GET', `users/me/school/groups/${groupId}/pupils`)
    return res.data.pupils
  },
  async getPupilsDiagnosticDataForGroup (groupId: number): Promise<PupilDiagnosticData[]> {
    const res = await this.request('GET', `users/me/school/groups/${groupId}/pupils_diagnostic_data`)
    return res.data.pupils
  },
  async getCompetenceForGroupByCurriculumNodeId (groupId: number, curriculumId: number): Promise<ExternalCurriculumNodeCompetenceInfo[]> {
    const res = await this.request('GET', `/users/me/school/groups/${groupId}/external_curricula/competence/parent_nodes`, { curriculumId })
    return res.data.group_competence
  },
  async getCompetenceForGroupByCurriculumNodeParentId (groupId: number, parentId: number): Promise<ExternalCurriculumNodeCompetenceInfo[]> {
    const res = await this.request('GET', `/users/me/school/groups/${groupId}/external_curricula/competence/child_nodes`, { parentId })
    return res.data.group_competence
  },
  async getGroupGrammarCompetence (groupId: number, stage: number, locale: NewPortalRegion): Promise<GrammarCompetenceDataByType[]> {
    const res = await this.request('GET', `/users/me/groups/${groupId}/grammar_competence`, { stage, locale })
    return res.data
  },
  async getGroupRecentSpellingAssessmentBreakdown (groupId: number, stage: number): Promise<UserAssessmentBreakdownItem[]> {
    const res = await this.request('GET', `/users/me/school/groups/${groupId}/recent_spelling_assessment_breakdown`, { stage })
    return res.data
  },
  async setNumberStageAllPupilsInGroup (groupId: number, stage_number: number): Promise<any> {
    const res = await this.request('PUT', `/users/me/school/groups/${groupId}/pupils/setnumberstage`, { stage_number })
    return res.data
  },
  async setSpellingStageAllPupilsInGroup (groupId: number, stage_spelling: number): Promise<any> {
    const res = await this.request('PUT', `/users/me/school/groups/${groupId}/pupils/setspellingstage`, { stage_spelling })
    return res.data
  },
  async getSubgroupsForGroup (groupId: number): Promise<GroupInfo[]> {
    const res = await this.request('GET', `/users/me/school/groups/${groupId}/groups`)
    return res.data.groups
  },
  async addSubgroup (groupId: number, name: string): Promise<GroupInfo> {
    const res = await this.request('POST', `/users/me/school/groups/${groupId}/groups`, { name })
    return res.data.group
  },
  async movePupilsToSubgroup (parentGroupId: number, subGroupId: number, pupils: number[]): Promise<Pupil[]> {
    const res = await this.request('POST', `/users/me/school/groups/${parentGroupId}/groups/${subGroupId}/pupils`, { pupils })
    return res.data.pupils
  },
  async removePupilsFromGroups (groupId: number | '*', pupils: number[] | '*'): Promise<boolean> {
    const res = await this.request('POST', `/users/me/school/groups/${groupId}/pupils/remove`, { pupils })
    return res.data.success
  },
  // #endregion
  // #region Homework
  // Return type varies depending on user's permissions, paging, and filters - see generic arguments
  async getHomework<R extends TeacherHomework<TPupils, TGroups, TTeachers> | PupilHomework, T extends TableQuery | undefined, TPupils extends boolean | undefined, TGroups extends boolean | undefined, TTeachers extends boolean | undefined> (filters: HomeworkUserFilters<TPupils, TGroups, TTeachers>, tableQuery?: T, isNewEdShedPortal = false): Promise<T extends undefined ? R[] : PagedResults<R>> {
    const res = await this.request('GET', 'homework', { ...tableQuery, ...filters, isNewEdShedPortal })
    return res.data.homework
  },
  async getHomeworkByID (homeworkId: number): Promise<TeacherHomework<true, true, true>> {
    const res = await this.request('GET', `homework/${homeworkId}`)
    return res.data.homework
  },
  async getHomeworkData (homeworkId: number): Promise<HomeworkData[]> {
    const res = await this.request('GET', `homework/${homeworkId}/data`)
    return res.data.homework
  },
  async getHomeworkSessions (homeworkId: number, userIds?: number[]): Promise<HomeworkSessionData[]> {
    const res = await this.request('GET', `homework/${homeworkId}/sessions`, { user_ids: userIds })
    return res.data.sessions
  },
  async getHomeworkNumberData (homeworkId: number): Promise<HomeworkData[]> {
    const res = await this.request('GET', `homework/${homeworkId}/numberdata`)
    return res.data.homework
  },
  async getHomeworkGrammarData (homeworkId: number): Promise<HomeworkData[]> {
    const res = await this.request('GET', `homework/${homeworkId}/grammardata`)
    return res.data.homework
  },
  async getHomeworkQuizData (homeworkId: number): Promise<HomeworkData[]> {
    const res = await this.request('GET', `homework/${homeworkId}/quizdata`)
    return res.data.homework
  },
  async getHomeworkNumberSessions (homeworkId: number, userIds?: number[]): Promise<HomeworkSessionData[]> {
    const res = await this.request('GET', `homework/${homeworkId}/numbersessions`, { user_ids: userIds })
    return res.data.sessions
  },
  async getHomeworkQuizSessions (homeworkId: number, userIds?: number[]): Promise<HomeworkSessionData[]> {
    const res = await this.request('GET', `homework/${homeworkId}/quizsessions`, { user_ids: userIds })
    return res.data.sessions
  },
  async getHomeworkPhonicsSessions (homeworkId: number, userIds?: number[]): Promise<HomeworkSessionData[]> {
    const res = await this.request('GET', `homework/${homeworkId}/phonicssessions`, { user_ids: userIds })
    return res.data.sessions
  },
  async getHomeworkGrammarSessions (homeworkId: number, userIds?: number[]): Promise<GrammarHomeworkSessionData[]> {
    const res = await this.request('GET', `homework/${homeworkId}/grammarsessions`, { user_ids: userIds })
    return res.data.sessions
  },
  async getHomeworkPhonicsData (homeworkId: number): Promise<HomeworkData[]> {
    const res = await this.request('GET', `homework/${homeworkId}/phonicsdata`)
    return res.data.homework
  },
  async getHomeworkLessonData (homeworkId: number): Promise<HomeworkData[]> {
    const res = await this.request('GET', `homework/${homeworkId}/lessondata`)
    return res.data.homework
  },
  async addPupilsToHomework (homeworkId: number, pupilIds: number[]): Promise<boolean> {
    const res = await this.request('POST', `homework/${homeworkId}/pupils`, { pupilIds })
    return res.data.success
  },
  async removePupilsFromHomework (homeworkId: number, pupilIds: number[]): Promise<boolean> {
    const res = await this.request('DELETE', `homework/${homeworkId}/pupils`, { pupilIds })
    return res.data.success
  },
  async addGroupToHomework (homeworkId: number, groupId: number): Promise<{ success: boolean, addedPupils: number[], addedTeachers: number[] }> {
    const res = await this.request('PUT', `homework/${homeworkId}/group/${groupId}`)
    return res.data
  },
  async removeGroupFromHomework (homeworkId: number, groupId: number): Promise<{ success: boolean, removedPupils: number[], removedTeachers: number[] }> {
    const res = await this.request('DELETE', `homework/${homeworkId}/group/${groupId}`)
    return res.data
  },
  async deleteHomework (homeworkId: number): Promise<boolean> {
    const res = await this.request('DELETE', `homework/${homeworkId}`)
    return res.data.success
  },
  async deleteHomeworks (homeworkIds: number[]): Promise<number[]> {
    const res = await this.request('DELETE', 'homework', { ids: homeworkIds })
    return res.data.deletedIds
  },
  async deleteSpellingGameplay (pupilUsername: string, gameplayId: number): Promise<SpellingGameInfo> {
    const res = await this.request('DELETE', `users/me/school/pupils/${pupilUsername}/history/${gameplayId}`)
    return res.data.session
  },
  async deleteBeekeeperGameplay (pupilUsername: string, gameplayId: number): Promise<BeekeeperGameInfo> {
    const res = await this.request('DELETE', `users/me/school/pupils/${pupilUsername}/beekeeperhistory/${gameplayId}`)
    return res.data.session
  },
  async deleteBuzzwordsGameplay (pupilUsername: string, gameplayId: number): Promise<BuzzwordsGameInfo> {
    const res = await this.request('DELETE', `users/me/school/pupils/${pupilUsername}/buzzwordshistory/${gameplayId}`)
    return res.data.session
  },
  async deleteQuizGamePlay (pupilUsername: string, gameplayId: UUID): Promise<QuizSessionState> {
    const res = await this.request('DELETE', `quiz/session/${gameplayId}`)
    return res.data.session
  },
  async createHomework (opt: AddHomeworkOptions): Promise<TeacherHomework<true, true, true>> {
    const res = await this.request('POST', 'homework', opt)
    return res.data.homework
  },
  async updateHomework (homeworkId: number, opt: AddHomeworkOptions): Promise<TeacherHomework<true, true, true>> {
    const res = await this.request('PUT', `homework/${homeworkId}`, opt)
    return res.data.homework
  },
  async createHomeworkSet (set: AddHomeworkSetRequest): Promise<HomeworkSetInfo> {
    const res = await this.request('POST', 'homework/multi', set)
    return res.data.homework_set
  },
  async updateHomeworkSet (setId: number, set: EditHomeworkSetRequest): Promise<HydratedHomeworkSetInfo> {
    const res = await this.request('PUT', 'homework/multi/' + setId, set)
    return res.data.homework_set
  },
  async addTeacherToHomework (homeworkId: number, userId: number): Promise<{ success: boolean }> {
    const res = await this.request('POST', `homework/${homeworkId}/teachers/${userId}`)
    return res.data
  },
  async removeTeacherFromHomework (homeworkId: number, userId: number): Promise<{ success: boolean }> {
    const res = await this.request('DELETE', `homework/${homeworkId}/teachers/${userId}`)
    return res.data
  },
  async getSpellingDiagnosticSkills (options: { stage: number, term: number, locale: Locale }): Promise<SpellingDiagnosticWord[]> {
    const res = await this.request('GET', 'spelling_diagnostic_skills', options)
    return res.data.words
  },
  // Return type varies depending on user's permissions, paging, and filters - see generic arguments
  async getHomeworkForGroup<R extends HomeworkInfo, T extends TableQuery | undefined, TPupils extends boolean | undefined, TGroups extends boolean | undefined, TTeachers extends boolean | undefined> (groupId: number, filters?: Omit<HomeworkUserFilters<TPupils, TGroups, TTeachers>, 'group_id'>, tableQuery?: T): Promise<T extends undefined ? (R extends TeacherHomework<TPupils, TGroups, TTeachers> ? TeacherHomework<TPupils, TGroups, TTeachers> : R)[] : PagedResults<(R extends TeacherHomework<TPupils, TGroups, TTeachers> ? TeacherHomework<TPupils, TGroups, TTeachers> : R)>> {
    const res = await this.request('GET', `homework/group/${groupId}`, { ...tableQuery, ...filters })
    return res.data.homeworks
  },
  async detachHomeworks (homeworkIds: number[]): Promise<boolean> {
    const res = await this.request('PATCH', 'homework/multi', { ids: homeworkIds })
    return res.data.success
  },
  async deleteHomeworkSets (homeworkSetIds: number[]): Promise<boolean> {
    const res = await this.request('DELETE', 'homework/multi', { ids: homeworkSetIds })
    return res.data.success
  },
  async getHomeworkSets (group_id?: number): Promise<HomeworkSetInfo[]> {
    const res = await this.request('GET', 'homework/multi', { group_id })
    return res.data.homework_sets
  },
  async getHomeworkSet (setId: number): Promise<HydratedHomeworkSetInfo> {
    const res = await this.request('GET', 'homework/multi/' + setId)
    return res.data.homework_set
  },
  async getCompetenceDataForHomeworkSet (setId: number): Promise<HomeworkSetCompetenceData> {
    const res = await this.request('GET', 'homework/multi/' + setId + '/competence')
    return res.data
  },
  async getGroupQuestionSetTestsData (group_id: number, filters: QuestionSetTestsFilters): Promise<PupilQuestionSetTestsData[]> {
    const res = await this.request('GET', `/homework/group/${group_id}/question_sets/tests`, filters)
    return res.data.tests
  },
  async getPupilQuestionSetTestsData (pupil_id: number, filters: QuestionSetTestsFilters): Promise<PupilQuestionSetTestsData[]> {
    const res = await this.request('GET', `/homework/pupil/${pupil_id}/question_sets/tests`, filters)
    return res.data.tests
  },
  // #endregion
  // #region Hives
  async getHiveGames (filters: GetHiveGamesFilters, table: TableQuery): Promise<PagedResults<HiveGameInfo>> {
    const res = await this.request('GET', 'hives', { ...filters, ...table })
    return res.data.hives
  },
  async getHive (hiveId: number): Promise<HiveGameData> {
    const res = await this.request('GET', `hives/${hiveId}`)
    return res.data.hive
  },
  async getHiveData (hiveId: number): Promise<HiveGameInfo> {
    const res = await this.request('GET', `hive/${hiveId}`)
    return res.data.hive
  },
  async deleteHive (hiveId: number): Promise<boolean> {
    const res = await this.request('DELETE', `hives/${hiveId}`)
    return res.data.success
  },
  // #endregion
  // #region Activity
  async getSchoolSpellingActivity (): Promise<Activity[]> {
    const res = await this.request('GET', 'users/me/school/activity')
    return res.data.activity
  },
  async getSchoolMathsActivity (): Promise<Activity[]> {
    const res = await this.request('GET', 'users/me/school/activitymaths')
    return res.data.activity
  },
  async getSchoolQuizActivity (): Promise<QuizActivity[]> {
    const res = await this.request('GET', 'users/me/school/activityquiz')
    return res.data.activity
  },
  // #endregion
  // #region Leagues
  async getCustomLeagues (isNewEdShedPortal = false): Promise<CustomLeague[]> {
    const res = await this.request('GET', 'users/me/leagues', { isNewEdShedPortal })
    return res.data.leagues
  },

  async getLeagueResults (leagueId: number, table: TableQuery): Promise<{ query: CustomLeagueQuery, pupils: PagedResults<LeagueResultRow> }> {
    const res = await this.request('GET', `leagues/custom/${leagueId}/results`, table)
    return res.data
  },
  // #endregion
  // #region Challenge
  async getChallengeGroups (challengeId: number): Promise<CustomLeagueGroup[]> {
    const res = await this.request('GET', `leagues/challenges/${challengeId}/groups`)
    return res.data.groups
  },
  async getChallengeUsers (challengeId: number): Promise<CustomLeagueUser[]> {
    const res = await this.request('GET', `leagues/challenges/${challengeId}/users`)
    return res.data.users
  },
  async getChallenges (): Promise<CustomLeague[]> {
    const res = await this.request('GET', 'leagues/challenges')
    return res.data.leagues
  },
  async createChallenge (payload: CreateChallengeRequest): Promise<CustomLeague> {
    const res = await this.request('POST', 'leagues/challenges', payload)
    return res.data.league
  },
  async updateChallenge (challengeId: number, payload: UpdateChallengeRequest): Promise<CustomLeague> {
    const res = await this.request('PUT', `leagues/custom/${challengeId}`, payload)
    return res.data
  },
  async deleteChallenge (challengeId: number): Promise<CustomLeague[]> {
    const res = await this.request('DELETE', `leagues/custom/${challengeId}`)
    return res.data
  },
  async getChallengeNotifications (product?: 'spelling' | 'number' | 'quiz' | 'phonics'): Promise<CustomLeague[]> {
    const res = await this.request('GET', 'users/me/challengenotifications', { product })
    return res.data.challenges
  },
  // #endregion
  // #region Teachers
  async addTeacher (options: AddTeacherRequest): Promise<Teacher> {
    const res = await this.request('POST', 'users/me/school/teachers', options)
    return res.data.teacher
  },
  async updateTeacher (teacherId: number, options: TeacherUpdateRequest): Promise<Teacher> {
    const res = await this.request('PATCH', `users/me/school/teachers/${teacherId}`, options)
    return res.data.teacher
  },
  async getTeachers (): Promise<Teacher[]> {
    const res = await this.request('GET', 'users/me/school/teachers')
    return res.data.teachers
  },
  async getTeachersInGroup (groupId: number): Promise<Teacher[]> {
    const res = await this.request('GET', `users/me/school/groups/${groupId}/teachers`)
    return res.data.teachers
  },
  async generateSchoolCode (): Promise<string> {
    const res = await this.request('POST', 'users/me/school/code')
    return res.data.user
  },
  async superuserGenerateCodeForSchool (schoolId: number): Promise<string> {
    const res = await this.request('POST', `superuser/schools/${schoolId}/generatecode`)
    return res.data.code
  },
  async resetSchoolCode (): Promise<any> {
    const res = await this.request('DELETE', 'users/me/school/code')
    return res.data.user
  },
  async checkSchoolCode (schoolId: number, code: string): Promise<boolean> {
    const res = await this.request('POST', 'schools/existence', { schoolId, code })
    return res.data.success
  },
  async getSchoolByCode (code: string): Promise<SchoolModel | null> {
    const res = await this.request('GET', `schools/existence?code=${code}`)
    return res.data.school
  },
  async inviteTeacher (email: string | string[]): Promise<any> {
    const res = await this.request('POST', 'users/me/school/teachers/invite', { email })
    return res.data
  },
  async acceptTeacherInvite (code: string, password: string): Promise<any> {
    const res = await this.request('POST', 'users/teacherinvite', { code, password })
    return res.data
  },
  async deleteTeacher (id: number): Promise<Teacher[]> {
    const res = await this.request('DELETE', `/users/me/school/teachers/${id}`)
    return res.data
  },
  // #endregion

  // #region Events
  async getEvents (eventsFilter: GetEventsParams, tableQuery: TableQuery): Promise<PagedResults<EventLogInfo>> {
    const res = await this.request('GET', 'events', { ...eventsFilter, ...tableQuery })
    return res.data.events
  },

  async searchUsers (term: string, schoolId?: number): Promise<UserModel[]> {
    const query: any = { q: term }

    if (schoolId) {
      query.schoolid = schoolId
    }

    const res = await this.request('GET', 'users', query)
    return res.data.users
  },

  async searchUsersInSchool (term: string): Promise<UserModel[]> {
    const query: any = { q: term }

    const res = await this.request('GET', 'users/me/school/users', query)
    return res.data.users
  },

  async setAllSchoolsUsersExperimental (enabled: boolean): Promise<boolean> {
    const res = await this.request('PUT', 'users/me/school/users/experimental', { enabled })
    return res.data.success
  },

  async setAllSchoolsTeachersExperimental (enabled: boolean): Promise<boolean> {
    const res = await this.request('PUT', 'users/me/school/teachers/experimental', { enabled })
    return res.data.success
  },

  async setAllSchoolsPupilsExperimental (enabled: boolean): Promise<boolean> {
    const res = await this.request('PUT', 'users/me/school/pupils/experimental', { enabled })
    return res.data.success
  },

  async setTeacherExperimental (teacherId: number, enabled: boolean): Promise<boolean> {
    const res = await this.request('PUT', `users/me/school/teachers/${teacherId}/experimental`, { enabled })
    return res.data.success
  },

  async setTeacherAdmin (teacherId: number): Promise<boolean> {
    const res = await this.request('PUT', `users/me/school/teachers/${teacherId}/admin`, {})
    return res.data.success
  },

  async unsetTeacherAdmin (teacherId: number): Promise<boolean> {
    const res = await this.request('DELETE', `users/me/school/teachers/${teacherId}/admin`, {})
    return res.data.success
  },

  async setPupilExperimental (pupilId: number, enabled: boolean): Promise<boolean> {
    const res = await this.request('PUT', `users/me/school/pupils/${pupilId}/experimental`, { enabled })
    return res.data.success
  },

  async setGroupTeachersExperimental (groupId: number, enabled: boolean): Promise<boolean> {
    const res = await this.request('PUT', `users/me/school/groups/${groupId}/teachers/experimental`, { enabled })
    return res.data.success
  },

  async setGroupPupilsExperimental (groupId: number, enabled: boolean): Promise<boolean> {
    const res = await this.request('PUT', `users/me/school/groups/${groupId}/pupils/experimental`, { enabled })
    return res.data.success
  },

  async searchLists<T extends TableQuery | undefined> (params: { q: string, locale?: Locale }, table?: T): Promise<MaybePaged<SearchListItem, T>> {
    const res = await this.request('GET', 'search', { ...params, ...table })
    return res.data.lists
  },

  async searchSchools<SuperUser extends boolean> (term: string, subscribed: boolean, dfe_schools?: boolean): Promise<SuperUser extends true ? SchoolModel[] : SimpleSchool[]> {
    const res = await this.request('GET', 'schools', { q: term, subscribed, dfe_schools })
    return res.data.schools
  },

  // #endregion

  // #region Subscriptions
  async grantFreemiumSubscription (): Promise<Subscription> {
    const res = await this.request('POST', 'users/me/school/subscriptions/freemium')
    return res.data.subscription
  },

  async getSchoolSubscriptions (): Promise<Subscription[]> {
    const res = await this.request('GET', 'users/me/school/subscriptions')
    return res.data.subscriptions
  },

  async superuserGetSchoolSubscriptions (schoolId: number): Promise<Subscription[]> {
    const res = await this.request('GET', `schoolsubscriptions/${schoolId}`)
    return res.data.subscriptions
  },

  async getSubscription (id: number): Promise<Subscription> {
    const res = await this.request('GET', `users/me/school/subscriptions/${id}`)
    return res.data.subscription
  },

  async getUsersAssignedSubscriptions (pupilIdent: string): Promise<any> {
    const res = await this.request('GET', 'users/me/school/pupils/' + pupilIdent + '/subscriptions')
    return res.data.subscriptions
  },

  async assignSubToUsers (subscription_id: number, user_ids: number[]): Promise<Subscription> {
    const res = await this.request('POST', `users/me/school/subscriptions/${subscription_id}/users`, { user_ids })
    return res.data.subscription
  },

  async removeSubFromUsers (subscription_id: number, user_ids: number[]): Promise<Subscription> {
    const res = await this.request('DELETE', `users/me/school/subscriptions/${subscription_id}/users`, { user_ids })
    return res.data.subscription
  },

  async assignSubToTeachers (subscription_id: number, user_ids: number[]): Promise<Subscription> {
    const res = await this.request('POST', `users/me/school/subscriptions/${subscription_id}/teachers`, { user_ids })
    return res.data.subscription
  },

  async removeSubFromTeachers (subscription_id: number, user_ids: number[]): Promise<Subscription> {
    const res = await this.request('DELETE', `users/me/school/subscriptions/${subscription_id}/teachers`, { user_ids })
    return res.data.subscription
  },

  async assignSubToClasses (subscription_id: number, group_ids: number[], assignToUsers: boolean, errorOnUserLimit: boolean = false): Promise<Subscription> {
    const res = await this.request('POST', `users/me/school/subscriptions/${subscription_id}/groups`, { group_ids, assign_to_users: assignToUsers, error_on_user_limit: errorOnUserLimit })
    return res.data.subscription
  },

  async removeSubFromClasses (subscription_id: number, group_ids: number[]): Promise<Subscription> {
    const res = await this.request('DELETE', `users/me/school/subscriptions/${subscription_id}/groups`, { group_ids })
    return res.data.subscription
  },

  async updatePupilSeats (id: number, seats: number): Promise<Subscription> {
    const res = await this.request('PATCH', `users/me/school/subscriptions/${id}/users/seats`, { seats })
    return res.data.subscription
  },

  async updateTeacherSeats (id: number, seats: number): Promise<Subscription> {
    const res = await this.request('PATCH', `users/me/school/subscriptions/${id}/teachers/seats`, { seats })
    return res.data.subscription
  },

  async getCoupon (coupon: string) { // return type is Stripe.Coupon
    const res = await this.request('GET', `coupons/${coupon}`)
    return res.data.coupon
  },

  async getCoupons () { // return type is Stripe.Coupon[]
    const res = await this.request('GET', 'coupons')
    return res.data.coupons
  },

  async getInvoiceByShareableId (shareableIdent: string): Promise<StripeInvoiceInfo> {
    const res = await this.request('GET', `subscriptions/invoices/${shareableIdent}`)
    return res.data.invoice
  },

  async markInvoicePromised (invoiceId: string, reference: string | null) {
    await this.request('POST', `superuser/invoices/${invoiceId}/promised`, { reference })
  },

  async markInvoicePaid (invoiceId: string, method: StripeInvoicePaymentMethod, date: ISO8601Date) {
    await this.request('POST', `superuser/invoices/${invoiceId}/paid`, { method, date })
  },

  async markInvoiceLocallyVoid (invoiceId: number): Promise<StripeInvoiceInfo> {
    const res = await this.request('POST', `superuser/subscriptions/invoices/${invoiceId}/void`)
    return res.data.invoice
  },

  async getInvoices (table: TableQuery, filters: InvoiceFilter): Promise<PagedResults<StripeInvoiceInfo>> {
    const res = await this.request('GET', 'subscriptions/invoices', { ...table, ...filters })
    return res.data.data
  },

  async getUpgradeCost (subscription_id: string, params: GetUpgradeCostParams): Promise<SubscriptionUpgradeCostResponse> {
    const res = await this.request('GET', `users/me/school/subscriptions/${subscription_id}/upgrade`, params)
    return res.data
  },

  async getSubscriptionCost (params: SubscriptionUpgradeCostRequest): Promise<SubscriptionUpgradeCostResponse> {
    const res = await this.request('GET', 'users/me/school/subscriptions/cost', params)
    return res.data
  },

  async getSchoolsSubscriptionCost (id: number, params: SubscriptionUpgradeCostRequest): Promise<SubscriptionUpgradeCostResponse> {
    const res = await this.request('GET', `/schools/${id}/subscriptions/cost`, params)
    return res.data
  },

  async getInvoicesForSubscription (id: number): Promise<StripeInvoiceInfo[]> {
    const res = await this.request('GET', `users/me/school/subscriptions/${id}/invoices`)
    return res.data.invoices
  },

  async superuserGetInvoicesForSubscription (stripeId: string): Promise<StripeInvoiceInfo[]> {
    const res = await this.request('GET', `schoolstripeInvoices/${stripeId}`)
    return res.data.invoices
  },

  async uploadRemittance (invoiceId: string, date_received: Date, new_file: FileUpload) {
    const res = await this.request('POST', `/superuser/invoices/${invoiceId}/remittance`, { date_received, new_file })
    return res.data.response
  },

  async updateRemittance (invoiceId: string, date_received: Date, new_file?: FileUpload) {
    const res = await this.request('PUT', `/superuser/invoices/${invoiceId}/remittance`, { date_received, new_file })
    return res.data.response
  },

  async updateSubscription (id: number, poNumber: string): Promise<boolean> {
    const res = await this.request('PATCH', `/superuser/subscriptions/${id}`, { po_number: poNumber })
    return res.data.success
  },

  async updateSubscriptionBillingAddress (id: number, billingAddressId: number): Promise<Subscription> {
    const res = await this.request('PUT', `/subscriptions/${id}/billing_address`, { billing_address_id: billingAddressId })
    return res.data.subscription
  },

  async updateInvoice (id: number, params: UpdateInvoiceRequest): Promise<boolean> {
    const res = await this.request('PATCH', `stripe_invoices/${id}`, params)
    return res.data.success
  },

  async convertSubToStripe (id: number, params: ConvertSubscriptionRequest): Promise<Subscription> {
    const res = await this.request('POST', `/users/me/school/subscriptions/${id}/convert`, params)
    return res.data.subscription
  },

  async upgradeSubscription (id: number, params: UpgradeSubscriptionRequest): Promise<UpgradeSubscriptionResponse> {
    const res = await this.request('POST', `/users/me/school/subscriptions/${id}/upgrade`, params)
    return res.data
  },

  async updateSubscriptionPermissions (subId: number, perms: SubscriptionPermissions): Promise<boolean> {
    const res = await this.request('PATCH', `/superuser/subscriptions/${subId}/permissions`, perms)
    return res.data.success
  },

  async getRenewalEmail (subId: number): Promise<string> {
    const res = await this.request('GET', `/superuser/subscriptions/${subId}/renewal_email`)
    return res.data.email
  },

  async getNonCompliantSubs (table: TableQuery, filters: NonCompliantSubsFilters): Promise<PagedResults<NonCompliantSubData>> {
    const res = await this.request('GET', '/superuser/subscriptions/inferred_teacher_access', { ...table, ...filters })
    return res.data.subs
  },

  async refreshNonCompliantSubsCache (): Promise<boolean> {
    const res = await this.request('POST', '/superuser/subscriptions/inferred_teacher_access/cache')
    return res.data.success
  },

  async updateTeachersInferredAccess (subId: number, value: boolean): Promise<boolean> {
    const res = await this.request('PUT', `/superuser/subscriptions/${subId}/inferred_teacher_access`, { inferred_teacher_access: value })
    return res.data.success
  },

  async getScheduledUpdate (region: 'GB' | 'US', scheduleId: string): Promise<ScheduledUpdateInfo> {
    const res = await this.request('GET', `/stripe/${region}/schedules/${scheduleId}`)
    return res.data
  },

  async cancelScheduledUpdate (region: 'GB' | 'US', scheduleId: string) {
    const res = await this.request('DELETE', `/stripe/${region}/schedules/${scheduleId}`)
    return res.data
  },

  async rescheduleUpdate (region: 'GB' | 'US', scheduleId: string, params: RescheduleUpdateRequest): Promise<RescheduleSubscriptionResponse> {
    const res = await this.request('POST', `/stripe/${region}/schedules/${scheduleId}`, params)
    return res.data
  },

  async setInvoiceSourcePerson (id: number, person: number): Promise<StripeInvoiceInfo> {
    const res = await this.request('PATCH', `/subscriptions/invoices/${id}/source_person`, { person })
    return res.data.purchase
  },
  async setInvoiceSourceDept (id: number, dept: SalesSourceDepts): Promise<StripeInvoiceInfo> {
    const res = await this.request('PATCH', `/subscriptions/invoices/${id}/source_dept`, { dept })
    return res.data.purchase
  },
  // #endregion

  // #region rewards
  async getRewards (schoolGroupId: number): Promise<UpdateRewardInfo[]> {
    const res = await this.request('GET', `/rewards/feedback/${schoolGroupId}`)
    return res.data.rewards
  },

  async addReward (reward: UpdateRewardInfo, schoolGroupId: number): Promise<number> {
    const res = await this.request('POST', `/rewards/feedback/${schoolGroupId}`, reward)
    return res.data.id
  },

  async deleteReward (rewardId: number): Promise<void> {
    await this.request('DELETE', `/rewards/feedback/${rewardId}`)
  },

  async updateReward (reward: UpdateRewardInfo, schoolGroupId: number): Promise<number> {
    const res = await this.request('PUT', `/rewards/feedback/${schoolGroupId}`, reward)
    return res.data.id
  },

  async getRewardGroups (schoolGroupId: number): Promise<RewardGroupWithPupilsInfo[]> {
    const res = await this.request('GET', `/rewards/groups/${schoolGroupId}`)
    return res.data.groups
  },

  async addRewardGroup (rewardGroup: AddRewardGroupInfo, schoolGroupId: number): Promise<number> {
    const res = await this.request('POST', `/rewards/groups/${schoolGroupId}`, rewardGroup)
    return res.data.id
  },

  async deleteRewardGroup (rewardGroupId: number, schoolGroupId: number): Promise<void> {
    await this.request('DELETE', `/rewards/groups/${schoolGroupId}`, { rewardGroupId })
  },

  async addPupilToRewardGroup (rewardGroupId: number, pupilId: number): Promise<number> {
    const res = await this.request('POST', `/rewards/groups/${rewardGroupId}/pupils`, { pupilId })
    return res.data.id
  },

  async deletePupilInRewardGroup (rewardGroupId: number, pupilId: number): Promise<void> {
    await this.request('DELETE', `/rewards/groups/${rewardGroupId}/pupils`, { pupilId })
  },

  async updateRewardGroupName (rewardGroupId: number, groupName: string): Promise<void> {
    await this.request('PUT', `/rewards/groups/${rewardGroupId}/name`, { groupName })
  },

  async rewardPupil (rewardPupilBody: RewardPupilInfo): Promise<void> {
    await this.request('POST', '/rewards/score', rewardPupilBody)
  },

  async rewardPupilAnonymous (rewardPupilBody: RewardPupilAnonymousInfo): Promise<void> {
    await this.request('POST', '/rewards/score/anonymous', rewardPupilBody)
  },

  async rewardPupilWithEarnings (rewardPupilBody: RewardPupilEarningsInfo): Promise<boolean> {
    const res = await this.request('POST', '/rewards/earnings/score', rewardPupilBody)
    return res.data.successful
  },

  async getRewardLogs (schoolGroupId: number): Promise<RewardDataInfo[]> {
    const res = await this.request('GET', '/rewards/history', { schoolGroupId })
    return res.data.rewardLogs
  },

  async deleteRewardLog (logId: number): Promise<void> {
    await this.request('DELETE', '/rewards/history', { logId })
  },

  async convertRewardPointsToEarnings (schoolGroupId: number): Promise<void> {
    await this.request('PUT', '/rewards/convert', { schoolGroupId })
  },
  // #endregion

  // #region recover deleted users
  async restoreDeletedUser (userId: number): Promise<UserModel> {
    const res = await this.request('DELETE', `/users/deleted/${userId}`)
    return res.data
  },

  async restoreDeletedUsers (userIds: number[]): Promise<boolean> {
    const res = await this.request('POST', 'users/me/school/users/deleted/recover', userIds)
    return res.data.success
  },

  async restoreDeletedUsersAll (): Promise<boolean> {
    const res = await this.request('POST', 'users/me/school/users/deleted/recover/all')
    return res.data.success
  },

  async getDeletedUsersForMySchool (table: TableQuery): Promise<PagedResults<DeletedUserInfo>> {
    const res = await this.request('GET', 'users/me/school/users/deleted', table)
    return res.data.users
  },

  async mergeDeletedUser (options: MergeDeletedUserOptions): Promise<boolean> {
    const response = await this.request('PATCH', 'users/me/school/users/deleted/merge', options)
    return response.data.success
  },

  async updateDeletedUser (id: number, options: UpdateDeletedUserOptions): Promise<DeletedUserInfo> {
    const res = await this.request('PATCH', `users/me/school/users/deleted/${id}`, options)
    return res.data.success
  },
  // #endregion

  // #region superuser

  async superuserSearchSchools (query: GetSchoolSubscriptionsParams, table: TableQuery): Promise<PagedResults<SuperUserSchoolSearchResult>> {
    const res = await this.request('GET', 'schoolsubscriptions', { ...query, ...table })
    return res.data.schools
  },

  async superuserDeleteSchool (schoolId: number): Promise<void> {
    await this.request('DELETE', `/superuser/schools/${schoolId}/deleteschool`)
  },

  async superuserSetExpiry (subId: number, expiry: ISO8601Date): Promise<void> {
    await this.request('POST', '/superuser/setexpiry', { subsId: subId, expiry })
  },

  async syncSubscription (subId: number) {
    await this.request('POST', '/superuser/syncsubscription', { subsId: subId })
  },

  async moveSubscription (subId: number, newSchoolId: number) {
    await this.request('POST', `/superuser/subscriptions/${subId}/move`, { school: newSchoolId })
  },

  async deleteSubscription (subId: number) {
    await this.request('DELETE', `/superuser/subscriptions/${subId}/delete`)
  },

  async cancelSubscriptionAtExpiry (stripeId: string): Promise<Subscription> {
    const res = await this.request('POST', '/superuser/cancelatexpiry', { subscriptionId: stripeId })
    return res.data.subscription
  },

  async uncancelSubscriptionAtExpiry (stripeId: string): Promise<Subscription> {
    const res = await this.request('DELETE', '/superuser/cancelatexpiry', { subscriptionId: stripeId })
    return res.data.subscription
  },

  async editCancellationReason (cancellationId: number, newReason: SubscriptionCancellationReason): Promise<boolean> {
    const res = await this.request('PATCH', `/superuser/cancellations/${cancellationId}/reason`, { newReason })
    return res.data
  },

  async getCancellationReasonsTable<P extends { notes?: boolean | undefined }> (filters: GetSubscriptionCancellationReasonsFilters, table: TableQuery, profile: P): Promise<PagedResults<CancellationInfo<P>>> {
    const res = await this.request('GET', '/superuser/subscriptions/cancellations', { ...filters, ...table, profile })
    return res.data
  },

  async getCancellationReasonsAggregated (filters: GetSubscriptionCancellationReasonsFilters): Promise<CancellationAggregateData[]> {
    const res = await this.request('GET', '/superuser/subscriptions/cancellations/aggregate', filters)
    return res.data
  },

  async deactivateSubscription (subId: number) {
    await this.request('POST', '/superuser/deactivatesubscription', { subsId: subId })
  },

  async cancelSubscriptionAndRefund (stripeId: string) {
    await this.request('POST', '/superuser/cancelandrefund', { subscriptionId: stripeId })
  },

  async cancelSubscriptionAndMarkVoid (stripeId: string) {
    await this.request('POST', '/superuser/cancelvoid', { subscriptionId: stripeId })
  },

  async cancelSubscriptionAndMarkUncollectable (stripeId: string) {
    await this.request('POST', '/superuser/canceluncollectable', { subscriptionId: stripeId })
  },

  async sendInvoiceToXero (id: number) {
    await this.request('POST', `/superuser/invoices/${id}/xero`)
  },

  async setInvoiceFinalAmount (id: number, finalAmount: number) {
    await this.request('POST', `/superuser/invoices/${id}/forex`, { amount_final: finalAmount })
  },

  async imitateUser (userId: number): Promise<UserModel> {
    const res = await this.request('POST', `/superuser/imitateuser/${userId}`)
    return res.data
  },

  async stopImitatingUser (): Promise<UserModel> {
    const res = await this.request('DELETE', '/superuser/imitateuser')
    return res.data
  },

  async setRoleForSchoolUser (userId: number, schoolId: number, role: UserRoles): Promise<{ success: boolean }> {
    const res = await this.request('PATCH', `/superuser/schools/${schoolId}/users/${userId}/role`, { role })
    return res.data
  },

  async getSchoolsPaymentMethods (schoolId: number) {
    const res = await this.request('GET', `/superuser/schools/${schoolId}/paymentMethods`)
    return res.data.paymentMethods
  },

  async getStripeEventsForSchool (schoolId: number): Promise<StripeEventStub[]> {
    const res = await this.request('GET', `/schools/${schoolId}/stripe/events`)
    return res.data.events
  },

  async getStripeInvoicesForSubscription (subId: number): Promise<object[]> {
    const res = await this.request('GET', `/subscriptions/${subId}/stripe/invoices`)
    return res.data.invoices
  },

  async postManualStripeInvoice (id: string, data: ManualInvoiceToAdd): Promise<StripeInvoiceInfo> {
    const res = await this.request('POST', `/subscriptions/${id}/stripe/invoices`, data)
    return res.data.invoice
  },

  async restoreStripeInvoice (id: string, region: StripeInvoiceAccountRegion): Promise<boolean> {
    const res = await this.request('POST', `/stripe/${region}/invoices/${id}`)
    return res.data.success
  },

  async rerunStripeEvent (eventId: string, region: StripeInvoiceAccountRegion): Promise<boolean> {
    const res = await this.request('POST', `/stripe/${region}/events/${eventId}`)
    return res.data.received
  },

  async superuserAddFreeSubscription (schoolId: number, data: SuperuserAddFreeSubscriptionRequest): Promise<Subscription> {
    const res = await this.request('POST', `/superuser/schools/${schoolId}/subscription/free`, data)
    return res.data.subscription
  },

  async superuserAddBackdatedSubscription (schoolId: number, data: SuperuserAddBackdatedSubscriptionRequest): Promise<SuperuserAddSubscriptionResponse> {
    const res = await this.request('POST', `/superuser/schools/${schoolId}/subscription/backdated`, data)
    return res.data
  },

  async superuserAddFutureSubscription (schoolId: number, data: SuperuserAddFutureSubscriptionRequest): Promise<boolean> {
    const res = await this.request('POST', `/superuser/schools/${schoolId}/subscription/future`, data)
    return res.data.success
  },

  async getSchoolsScheduledSubscriptions (schoolId: number): Promise<ScheduledSubscriptionInfo[]> {
    const res = await this.request('GET', `/superuser/schools/${schoolId}/subscription/future`)
    return res.data.schedules
  },

  async cancelSchoolsScheduledSubscription (schoolId: number, id: string): Promise<ScheduledSubscriptionInfo> {
    const res = await this.request('DELETE', `/superuser/schools/${schoolId}/subscription/future`, { id })
    return res.data.schedule
  },

  async superuserAddFullSubscription (schoolId: number, data: SuperuserAddFullSubscriptionRequest): Promise<SuperuserAddSubscriptionResponse> {
    const res = await this.request('POST', `/superuser/schools/${schoolId}/subscription/full`, data)
    return res.data
  },

  async superuserAddTrialSubscription (schoolId: number, data: SuperuserAddTrialSubscriptionRequest): Promise<Subscription> {
    const res = await this.request('POST', `/superuser/schools/${schoolId}/subscription/trial`, data)
    return res.data.subscription
  },

  async calculateOldAndNewShedScores (userId: number): Promise<{ oldScore: number, newScore: number }> {
    const res = await this.request('GET', `/users/${userId}/shed_score/spelling`)
    return res.data
  },

  async recacheUsersArchivedScores (userId: number): Promise<Partial<Scores>> {
    const res = await this.request('PUT', `/superuser/users/${userId}/scores/archive`)
    return res.data.scores
  },

  async recacheUsersTotalScores (userId: number): Promise<Partial<Scores>> {
    const res = await this.request('PUT', `/superuser/users/${userId}/scores/total`)
    return res.data.scores
  },

  async recacheUsersShedScores (userId: number): Promise<Partial<Scores>> {
    const res = await this.request('PUT', `/superuser/users/${userId}/scores/shed`)
    return res.data.scores
  },

  async getUsersSession (userId: number): Promise<UserModel> {
    const res = await this.request('GET', `/superuser/users/${userId}/session`)
    return res.data.session
  },

  // #region notes
  async addNote (data: AddNoteRequest): Promise<NoteInfo> {
    const res = await this.request('POST', '/notes', data)
    return res.data
  },

  async deleteNote (id: number): Promise<{ success: boolean }> {
    const res = await this.request('DELETE', `/notes/${id}`)
    return res.data
  },

  async editNote (id: number, data: EditNoteRequest): Promise<Omit<NoteInfo, 'target_type' | 'target_id'>> {
    const res = await this.request('PATCH', `/notes/${id}`, data)
    return res.data
  },

  async getNotesForTarget (type: NoteTarget, id: number): Promise<NoteInfo[]> {
    const res = await this.request('GET', `/notes/${type}/${id}`)
    return res.data
  },
  // #endregion

  // #region
  async getDictionaryData (tableQuery: TableQuery, filters: DictionaryFilters): Promise<PagedResults<DictionaryInfo>> {
    const res = await this.request('GET', '/dictionary', { ...tableQuery, ...filters })
    return res.data
  },

  async getDictionaryWord (id: number): Promise<DictionaryInfo> {
    const res = await this.request('GET', `/dictionary/${id}`)
    return res.data
  },

  async requestDictionaryDefinition (id: number): Promise<boolean> {
    const res = await this.request('POST', `/dictionary/${id}/prompt`)
    return res.data.success
  },

  async addDictionaryWord (data: AddDictionaryRequest): Promise<DictionaryInfo> {
    const res = await this.request('POST', '/dictionary', data)
    return res.data
  },

  async addUserDictionaryWord (data: AddUserDictionaryRequest): Promise<DictionaryInfo> {
    const res = await this.request('POST', '/users/me/dictionary', data)
    return res.data
  },

  async updateDictionaryWord (id: number, data: DictionaryDataToEdit): Promise<DictionaryInfo> {
    const res = await this.request('PUT', `/dictionary/${id}`, data)
    return res.data
  },

  async deleteDictionaryWord (id: number): Promise<boolean> {
    const res = await this.request('DELETE', `/dictionary/${id}`)
    return res.data.success
  },

  async duplicateDictionaryWord (id: number): Promise<DictionaryInfo> {
    const res = await this.request('POST', `/dictionary/${id}`)
    return res.data.word
  },

  async logLetterTileToolWord (word: string, locale: DictionaryLanguage, audio: boolean = false): Promise<boolean> {
    const res = await this.request('POST', '/dictionary/lettertiles/word', { word, locale, audio })
    return res.data.success
  },

  async getLetterTileToolWords (tableQuery: TableQuery, locale?: DictionaryLanguage): Promise<PagedResults<LetterTileToolTrackedWord>> {
    const res = await this.request('GET', '/dictionary/lettertiles/words', { ...tableQuery, locale })
    return res.data.words
  },

  async getHomographsOfWord (word: string, locale: DictionaryLanguage): Promise<DictionaryInfo[]> {
    const res = await this.request('GET', '/dictionary/homograph', { word, locale })
    return res.data.homographs
  },

  async getMyVersionOfWord (id: number): Promise<DictionaryInfo> {
    const res = await this.request('GET', `/dictionary/${id}/me`, { id })
    return res.data
  },

  async changeListWordDictionary (list_ident: string, word_ident: string, dictionary_id: number) {
    const res = await this.request('PUT', `/lists/${list_ident}/words/${word_ident}`, { dictionary_id })
    return res.data
  },

  async getOwnerNameOfWord (id: number) {
    const res = await this.request('GET', `/dictionary/${id}/user`)
    return res.data
  },

  async makeDictionaryWordHidden (id: number) {
    const res = await this.request('PUT', `/dictionary/${id}`, { hidden: true })
    return res.data
  },

  async getListsForDictionaryId (id: number, filters: GetListsForWordFilters, table: TableQuery): Promise<PagedResults<SpellingList>> {
    const res = await this.request('GET', `/dictionary/${id}/lists`, { ...filters, ...table })
    return res.data.lists
  },

  async mergeDictionaryWords (primaryId: number, secondaryId: number): Promise<DictionaryInfo> {
    const res = await this.request('POST', `/dictionary/${primaryId}/merge`, { merge_id: secondaryId })
    return res.data.word
  },
  // #endregion

  // #region phonics
  async addPhonicsAssessments (data: AddPhonicsAssessmentData, sessionId?: number): Promise<boolean> {
    const res = await this.request('POST', '/phonics/assessment', { data, sessionId })
    return res.data.success
  },

  async addScreeningAssessmentData (data: AddScreeningAssessmentData): Promise<boolean> {
    const res = await this.request('POST', '/phonics/assessment/screening', data)
    return res.data.success
  },

  async getPhonicsAssessmentsForPupil (pupil_id: number, element_type: PhonicsAssessmentType, element_id: number): Promise<PhonicsAssessmentInfo[]> {
    const res = await this.request('GET', `/phonics/assessment/history/${pupil_id}/${element_type}/${element_id}`)
    return res.data
  },

  async getScreeningAssessmentsForPupil (pupil_id: number): Promise<PhonicsAssessmentInfo[]> {
    const res = await this.request('GET', `/users/${pupil_id}/phonics_assessments`)
    return res.data
  },

  async getHfwDataForPupil (pupil_id: number, table: TableQuery): Promise<PagedResults<PhonicsWordAssessmentInfo>> {
    const res = await this.request('GET', `/phonics/assessment/${pupil_id}/hfw`, table)
    return res.data
  },

  async getPhonicsGroupComprehensionOnDateData (id: number, date: string): Promise<(PhonicsGroupComprehensionInfo)> {
    const res = await this.request('GET', `/phonics/assessment/group/${id}`, { date })
    return res.data
  },

  async getPhonicsGroupComprehensionData (id: number, start?: string, end?: string): Promise<(PhonicsGroupComprehensionInfo)> {
    const res = await this.request('GET', `/phonics/assessment/group/${id}`, { start, end })
    return res.data
  },

  async getPhonicsPupilComprehensionData (id: number, start?: string, end?: string): Promise<PhonicsUserComprehensionInfo> {
    const res = await this.request('GET', `/phonics/assessment/pupil/${id}`, { start, end })
    return res.data
  },

  async getAvailablePhonicsPurchases (id: number): Promise<PhonicsPurchases> {
    const res = await this.request('GET', `/schools/${id}/phonics/packs`)
    return res.data
  },

  async getWordPools () {
    const res = await this.request('GET', '/phonics/screening/pools')
    return res.data
  },

  async generateScreeningCheckData (): Promise<PhonicsScreeningQuestion[]> {
    const res = await this.request('GET', '/phonics/screening/generate')
    return res.data
  },

  async saveIndyPopSession (data: IndyPopSessionToSave): Promise<{ id: UUID, user: UserModel }> {
    const res = await this.request('POST', '/phonics/session/indy', data)
    return res.data
  },

  async saveBodyPercussionSession (data: PercussionSessionToSave): Promise<{ id: UUID, user: UserModel }> {
    const res = await this.request('POST', '/phonics/session/percussion', data)
    return res.data
  },

  async saveDareHareSession (data: DareSessionToSave): Promise<{ id: UUID, user: UserModel }> {
    const res = await this.request('POST', '/phonics/session/dare', data)
    return res.data
  },

  async saveCardMatchSession (data: CardMatchSessionToSave): Promise<{ id: UUID, user: UserModel }> {
    const res = await this.request('POST', '/phonics/session/match', data)
    return res.data
  },

  async saveSoundingOutSession (data: SoundingOutSessionToSave): Promise<{ id: UUID, user: UserModel }> {
    const res = await this.request('POST', '/phonics/session/sounding-out', data)
    return res.data
  },

  async saveSceneSoundsSession (data: SceneSoundsSessionToSave): Promise<{ id: UUID, user: UserModel }> {
    const res = await this.request('POST', '/phonics/session/scene-sounds', data)
    return res.data
  },

  async saveSoundboardSession (data: SoundboardSessionToSave): Promise<{ id: UUID, user: UserModel }> {
    const res = await this.request('POST', '/phonics/session/soundboard', data)
    return res.data
  },

  async saveSoundKeyboardSession (data: SoundKeyboardSessionToSave): Promise<{ id: UUID, user: UserModel }> {
    const res = await this.request('POST', '/phonics/session/sound-keyboard', data)
    return res.data
  },

  async getDecodableBooks (term?: string): Promise<DecodableBookStructure[]> {
    if (term) {
      const res = await this.request('GET', '/phonics/decodable-books', { term })
      return res.data
    } else {
      const res = await this.request('GET', '/phonics/decodable-books', null)
      return res.data
    }
  },

  async getGroupPhonicsHistory (groupId: number, tableQuery: TableQuery): Promise<PagedResults<QuizSessionSummary & PhonicsQuizSessionSummary>> {
    const res = await this.request('GET', `/users/me/school/groups/${groupId}/phonics/history`, { ...tableQuery })
    return res.data
  },

  async getPupilPhonicsHistory (pupilId: number, tableQuery: TableQuery): Promise<PagedResults<QuizSessionSummary & PhonicsQuizSessionSummary>> {
    const res = await this.request('GET', `/users/me/school/pupils/${pupilId}/phonics/history`, { ...tableQuery })
    return res.data
  },

  async getPhonemes (locale?: Locale): Promise<PhonemesInfo[]> {
    const res = await this.request('GET', '/phonics/phonemes', { locale })
    return res.data.phonemes
  },

  async addPhoneme (phoneme: AddPhonemesRequest): Promise<PhonemesInfo> {
    const res = await this.request('POST', '/phonics/phonemes', phoneme)
    return res.data.phoneme
  },

  async editPhoneme (id: number, phoneme: EditPhonemesRequest): Promise<PhonemesInfo> {
    const res = await this.request('PATCH', `/phonics/phonemes/${id}`, phoneme)
    return res.data.phoneme
  },

  async deletePhoneme (id: number): Promise<PhonemesInfo> {
    const res = await this.request('DELETE', `/phonics/phonemes/${id}`)
    return res.data.phoneme
  },

  async createPhonicsScreeningSession (sessionPupils: number[], name: string, groupId: number | null, listId: string | null, isAlien: boolean): Promise<PhonicsScreeningSession> {
    const res = await this.request('POST', '/phonics/screening/session', { sessionPupils, name, groupId, listId, isAlien })
    return res.data.session
  },

  async getPhonicsScreeningSession (sessionId: number, includeWords: boolean, includeUsers: boolean): Promise<PhonicsScreeningSession> {
    const res = await this.request('GET', `/phonics/screening/session/${sessionId}`, { includeWords, includeUsers })
    return res.data.session
  },

  async getPhonicsScreeningSessions<T extends TableQuery | undefined> (includeUsers: boolean, viewAll: boolean, paging?: T): Promise<MaybePaged<PhonicsScreeningSession, T>> {
    const res = await this.request('GET', '/phonics/screening/session', { includeUsers, viewAll, ...paging })
    return res.data.sessions
  },

  async deletePhonicsScreeningSession (sessionId: number): Promise<boolean> {
    const res = await this.request('DELETE', `/phonics/screening/session/${sessionId}`)
    return res.data.success
  },

  async editPhonicsScreeningSession (session_id: number, name: string): Promise<PhonicsScreeningSession> {
    const res = await this.request('PATCH', `/phonics/screening/session/${session_id}`, { name })
    return res.data.success
  },

  async getPupilDataForSession (sessionId: number, userIds?: number[]): Promise<PhonicsScreeningSessionData[]> {
    const res = await this.request('GET', `/phonics/screening/session/${sessionId}/users`, { userIds })
    return res.data.pupilData
  },

  async removePupilsFromSession (sessionId: number, userIds: number[]): Promise<boolean> {
    const res = await this.request('DELETE', `/phonics/screening/session/${sessionId}/users`, { userIds })
    return res.data.success
  },

  async addPupilsToSession (sessionId: number, userIds: number[]): Promise<PhonicsScreeningSession> {
    const res = await this.request('POST', `/phonics/screening/session/${sessionId}/users`, { userIds })
    return res.data.session
  },
  // #endregion

  // #region districts

  async getDistricts (table: TableQuery): Promise<PagedResults<District>> {
    const res = await this.request('GET', 'districts', table)
    return res.data
  },

  async addDistrictSub (parentSubId: number, schoolId: number, quantity: number, childSubId: number | null) {
    const res = await this.request('POST', `/users/me/district/schools/${schoolId}/subscriptions`, { parentSubscriptionId: parentSubId, subscriptionId: childSubId, quantity })
    return res.data
  },
  async addDistrictSchool (params: SchoolCreateRequest): Promise<SchoolModel> {
    const res = await this.request('POST', '/users/me/district/schools', params)
    return res.data.school
  },
  // #endregion

  // #region one roster
  async syncOneRoster (id: string, provider: OneRosterProvider, tenantId: number | null) {
    const res = await this.request('POST', `/one-roster/${provider}/school/${id}/sync`, { tenant_id: tenantId })
    return res.data
  },

  async getOneRosterDistrictChildren (id: string, provider: OneRosterProvider, tenantId: number | null): Promise<OneRosterOrg[]> {
    const res = await this.request('GET', `one-roster/${provider}/school/${id}/children`, { tenant_id: tenantId })
    return res.data.children
  },

  async linkSchoolToOneRosterOrg (schoolId: number, oneRosterId: string, provider: OneRosterProvider, tenantId: number | null) {
    const res = await this.request('PATCH', `schools/${schoolId}/one-roster/${provider}`, { id: oneRosterId, tenant_id: tenantId })
    return res.data
  },

  async createSchoolFromOneRoster (provider: OneRosterProvider, data: { id: string, tenant_id: number | null, locale: Locale, country_code: CountryCode, district_id: string }): Promise<boolean> {
    const res = await this.request('POST', `one-roster/${provider}/school`, data)
    return res.data.success
  },

  async getClassLinkTenants (name?: string): Promise<ClassLinkTenantInfo[]> {
    const res = await this.request('GET', '/class-link/tenants', { name })
    return res.data.tenants
  },

  async refreshClassLinkTenants (): Promise<boolean> {
    const res = await this.request('POST', '/class-link/tenants')
    return res.data.success
  },

  async getClassLinkOrgsForTenant (tenantId: number) {
    const res = await this.request('GET', `/class-link/tenants/${tenantId}/orgs`, null)
    return res.data
  },
  // #endregion

  // #region reports
  async getWordsSpelledByPupil (username: string): Promise<WordsSpelledReportRow[]> {
    const res = await this.request('GET', `/users/me/school/pupils/${username}/wordsspelled`, null)
    return res.data.data
  },

  async getWordsSpelledByGroup (id: number): Promise<WordsSpelledPerGroupReportRow[]> {
    const res = await this.request('GET', `/users/me/school/groups/${id}/wordsspelled`, null)
    return res.data.data
  },

  async getSpellingAssignmentBreakdown (groupId: number, stage: number): Promise<GroupAssignmentBreakdown> {
    const res = await this.request('GET', `/users/me/school/groups/${groupId}/spelling/overview`, { stage })
    return res.data
  },

  async getNumberAssignmentBreakdown (groupId: number): Promise<GroupAssignmentBreakdown> {
    const res = await this.request('GET', `/users/me/school/groups/${groupId}/number/overview`)
    return res.data
  },

  // #endregion

  // #region sales engagement report
  async previewEngagementSnapshotSchools (start: ISO8601Date, end: ISO8601Date, filters: SalesEngagementReportFilters, table: TableQuery): Promise<PagedResults<EngagementReportSchoolStub>> {
    const res = await this.request('POST', '/superuser/sales/reports/engagement/preview', { start, end, ...filters, ...table })
    return res.data
  },

  async generateEngagementSnapshot (start: ISO8601Date, end: ISO8601Date, filters: SalesEngagementReportFilters): Promise<EngagementReportSnapshotInfo> {
    const res = await this.request('POST', '/superuser/sales/reports/engagement/snapshots', { start, end, ...filters })
    return res.data
  },

  async getEngagementSnapshot (id: number): Promise<EngagementReportSnapshotInfo> {
    const res = await this.request('GET', `/superuser/sales/reports/engagement/snapshots/${id}`, null)
    return res.data
  },

  async filterEngagementSnapshot (id: number, table: TableQuery): Promise<PagedResults<EngagementReportSchoolInfo>> {
    const res = await this.request('GET', `/superuser/sales/reports/engagement/snapshots/${id}/data`, table)
    return res.data
  },

  async downloadEngagementSnapshot (id: number, table: TableQuery) {
    const res = await rawRequest('GET', `/superuser/sales/reports/engagement/snapshots/${id}/download`, table, 'text')
    return res.data
  },

  async getEngagementSnapshots (table: TableQuery): Promise<PagedResults<EngagementReportSnapshotInfo>> {
    const res = await this.request('GET', '/superuser/sales/reports/engagement/snapshots', table)
    return res.data
  },

  async deleteEngagementSnapshot (id: number): Promise<{ success: boolean }> {
    const res = await this.request('DELETE', `/superuser/sales/reports/engagement/snapshots/${id}`, null)
    return res.data
  },

  async getSalesHeadlines (params: HeadlineSalesRequest): Promise<HeadlineSalesResponse> {
    const res = await this.request('GET', '/superuser/sales/reports/headlines', params)
    return res.data.data
  },

  async getRetentionEvents (params: GetRetentionEventsRequest, table: TableQuery): Promise<PagedResults<GetRetentionEventsResponse>> {
    const res = await this.request('GET', '/superuser/sales/reports/retentions/events', { ...params, ...table })
    return res.data.events
  },

  async updateRetentionEvent (id: number, data: EditRetentionEventRequest): Promise<GetRetentionEventsResponse> {
    const res = await this.request('PATCH', `/superuser/sales/reports/retentions/events/${id}`, data)
    return res.data.events
  },

  async getSalesByTypeGraph (params: SalesByTypeGraphRequest): Promise<SalesByTypeGraphResponse> {
    const res = await this.request('GET', '/superuser/sales/reports/salesByType', params)
    return res.data.data
  },

  async getRetentionsGraph (params: SalesByTypeGraphRequest): Promise<RetentionGraphResponse> {
    const res = await this.request('GET', '/superuser/sales/reports/retentions', params)
    return res.data.data
  },

  async getSalesByPerson (params: SalesByPersonRequest): Promise<SalesByPersonResponse> {
    const res = await this.request('GET', '/sales/reports/salesByPerson', params)
    return res.data.data
  },

  async getSalesByDept (params: SalesByDeptRequest): Promise<SalesByDeptResponse> {
    const res = await this.request('GET', '/sales/reports/salesByDept', params)
    return res.data.data
  },

  async getSalesPersons (table: TableQuery, filters: SalesPersonFilters): Promise<PagedResults<SalesPerson>> {
    const res = await this.request('GET', '/superuser/sales/salesPerson', { ...table, ...filters })
    return res.data.salesPersons
  },

  async createSalesPerson (name: string): Promise<number> {
    const res = await this.request('POST', '/superuser/sales/salesPerson', { name })
    return res.data.success
  },

  async editSalesPerson (person: Partial<SalesPerson> & Pick<SalesPerson, 'id'>): Promise<SalesPerson> {
    const res = await this.request('PATCH', `/superuser/sales/salesPerson/${person.id}`, person)
    return res.data.salesPersonToEdit
  },

  async deactivateSalesPerson (id: number): Promise<SalesPerson> {
    return this.editSalesPerson({ id, is_active: 0 })
  },

  async reactivateSalesPerson (id: number): Promise<SalesPerson> {
    return this.editSalesPerson({ id, is_active: 1 })
  },

  async deleteSalesPerson (person: SalesPerson): Promise<boolean> {
    const res = await this.request('DELETE', `/superuser/sales/salesPerson/${person.id}`)
    return res.data.success
  },
  // #endregion

  // #region countries

  async getCountries (): Promise<CountryInfo[]> {
    const res = await this.request('GET', '/countries', {})
    return res.data.countries
  },

  async getCountry (code: CountryCode): Promise<CountryInfo> {
    const res = await this.request('GET', `/countries/${code}`, {})
    return res.data.country
  },

  async editCountry (code: CountryCode, data: EditCountryRequestData): Promise<CountryInfo> {
    const res = await this.request('PATCH', `/countries/${code}`, data)
    return res.data.country
  },

  async getCountriesZones (country_id: number | null): Promise<CountryZoneInfo[]> {
    let res

    if (country_id === null) {
      res = await this.request('GET', '/countries/zones', {})
    } else {
      res = await this.request('GET', `/countries/${country_id}/zones`, {})
    }
    return res.data.zones
  },

  async getCountryZone (code: ZoneCode): Promise<CountryZoneInfo> {
    const res = await this.request('GET', `/countries/${code}`, {})
    return res.data.zone
  },

  // #endregion

  // #region merch store
  async getAllMerchSales (table: TableQuery, filters: MerchPurchaseFilters): Promise<PagedResults<MerchPurchase>> {
    const res = await this.request('GET', '/superuser/merchsales', { ...table, ...filters })
    return res.data.data
  },

  async getMerchPurchaseByShareableId (shareableId: string): Promise<MerchPurchase> {
    const res = await this.request('GET', `/store/purchases/${shareableId}`, {})
    return res.data.purchase
  },

  async getMyPurchases (): Promise<MerchPurchase[]> {
    const res = await this.request('GET', '/store/purchases')
    return res.data.purchases
  },

  async saveDraftMerchInvoice (params: Omit<AddMerchPurchaseRequest, 'school_id'>, skipEmail?: boolean): Promise<MerchPurchase> {
    const res = await this.request('POST', '/store/purchases/draft', { ...params, skip_email: skipEmail })
    return res.data.purchase
  },

  async purchaseMerchByInvoice (params: AddMerchPurchaseRequest, skipEmail?: boolean): Promise<MerchPurchase> {
    const res = await this.request('POST', '/store/purchases/invoice', { ...params, skip_email: skipEmail })
    return res.data.purchase
  },

  async purchaseMerchByCard (params: AddMerchPurchaseRequest, paymentMethod: string, skipEmail?: boolean): Promise<{ payment_intent_id: string, client_secret: string | null, purchase: MerchPurchase }> {
    const res = await this.request('POST', '/store/purchases', { ...params, paymentMethod, skip_email: skipEmail })
    return res.data
  },

  async editDraftInvoice (id: number, data: EditDraftPurchaseRequest): Promise<MerchPurchase> {
    const res = await this.request('PATCH', `/store/purchases/${id}`, data)
    return res.data.purchase
  },

  async setMerchShippingCost (id: number, cost: number): Promise<MerchPurchase> {
    const res = await this.request('PATCH', `/store/purchases/${id}/shipping`, { cost })
    return res.data.purchase
  },

  async setMerchFinalised (id: number, skipEmail: boolean): Promise<MerchPurchase> {
    const res = await this.request('PATCH', `/store/purchases/${id}/finalised`, { skip_email: skipEmail })
    return res.data.purchase
  },

  async setMerchPromised (id: number): Promise<MerchPurchase> {
    const res = await this.request('PATCH', `/store/purchases/${id}/promised`)
    return res.data.purchase
  },

  async setMerchPaid (id: number): Promise<MerchPurchase> {
    const res = await this.request('PATCH', `/store/purchases/${id}/paid`)
    return res.data.purchase
  },

  async setMerchShipped (id: number): Promise<MerchPurchase> {
    const res = await this.request('PATCH', `/store/purchases/${id}/shipped`)
    return res.data.purchase
  },

  async setMerchVoid (id: number): Promise<MerchPurchase> {
    const res = await this.request('PATCH', `/store/purchases/${id}/void`)
    return res.data.purchase
  },

  async setPONumber (options: SetPoNumberOptions): Promise<MerchPurchase> {
    const res = await this.request('PATCH', `/store/purchases/${options.id}/po_number`, options)
    return res.data.purchase
  },

  async deletePONumber (options: SetPoNumberOptions): Promise<MerchPurchase> {
    const res = await this.request('DELETE', `/store/purchases/${options.id}/po_number`, options)
    return res.data.purchase
  },

  async deleteMerchOrder (id: number): Promise<MerchPurchase> {
    const res = await this.request('DELETE', `/store/purchases/${id}`)
    return res.data.purchase
  },

  async getStoreItems (filters: GetMerchStoreItemsFilters, table: TableQuery): Promise<PagedResults<StoreItem>> {
    const res = await this.request('GET', '/store/items', { ...filters, ...table })
    return res.data
  },

  async getStoreItemFilters (): Promise<StoreItemFilter[]> {
    const res = await this.request('GET', '/store/item_filters')
    return res.data
  },

  async addMerchStoreItem (options: AddMerchProductOptions): Promise<StoreItem> {
    const res = await this.request('POST', '/store/items', options)
    return res.data.item
  },

  async editMerchStoreItem (id: number, options: Partial<AddMerchProductOptions>): Promise<StoreItem> {
    const res = await this.request('PATCH', `/store/items/${id}`, options)
    return res.data.item
  },

  async getMerchStoreItem (id: number): Promise<StoreItem> {
    const res = await this.request('GET', `/store/items/${id}`)
    return res.data.item
  },

  async getMerchStoreItemBySku (sku: string): Promise<StoreItem> {
    const res = await this.request('GET', `/store/items/sku/${sku}`)
    return res.data.item
  },

  async updateMerchStock (productId: number, params: UpdateMerchStockRequest): Promise<StoreItem> {
    const res = await this.request('PUT', `/store/items/${productId}/stock`, params)
    return res.data.item
  },

  async getMerchLocation (id: number): Promise<MerchLocationInfo> {
    const res = await this.request('GET', `store/locations/${id}`)
    return res.data.location
  },

  async getMerchLocations (query: TableQuery): Promise<PagedResults<MerchLocationInfo>> {
    const res = await this.request('GET', 'store/locations', query)
    return res.data.locations
  },

  async setMerchSourcePerson (id: number, person: number): Promise<MerchPurchase> {
    const res = await this.request('PATCH', `/store/purchases/${id}/source_person`, { person })
    return res.data.purchase
  },

  async setMerchSourceDept (id: number, dept: SalesSourceDepts): Promise<MerchPurchase> {
    const res = await this.request('PATCH', `/store/purchases/${id}/source_dept`, { dept })
    return res.data.purchase
  },
  // #endregion

  // #region Subscription Plans
  async addSubscriptionProduct (data: AddSubscriptionProductRequest): Promise<SubscriptionProductInfo> {
    const res = await this.request('POST', '/subscriptions/products', data)
    return res.data.product
  },

  async getSubscriptionProduct (id: number): Promise<SubscriptionProductInfo> {
    const res = await this.request('GET', `/subscriptions/products/${id}`)
    return res.data.product
  },

  async getSubscriptionProducts (table: TableQuery): Promise<PagedResults<SubscriptionProductInfo>> {
    const res = await this.request('GET', '/subscriptions/products', { ...table })
    return res.data.products
  },

  async updateSubscriptionProduct (id: number, data: EditSubscriptionProductRequest): Promise<SubscriptionProductInfo> {
    const res = await this.request('PATCH', `/subscriptions/products/${id}`, data)
    return res.data.product
  },

  async deleteSubscriptionProduct (id: number): Promise<SubscriptionProductInfo> {
    const res = await this.request('DELETE', `/subscriptions/products/${id}`)
    return res.data.product
  },

  async addSubscriptionProductScope (productId: number, data: AddSubscriptionProductScopeRequest): Promise<SubscriptionProductScopeInfo> {
    const res = await this.request('POST', `/subscriptions/products/${productId}/scopes`, data)
    return res.data.scope
  },

  async updateSubscriptionProductScope (id: number, data: EditSubscriptionProductScopeRequest): Promise<SubscriptionProductScopeInfo> {
    const res = await this.request('PATCH', `/subscriptions/scopes/${id}`, data)
    return res.data.scope
  },

  async deleteSubscriptionProductScope (id: number): Promise<SubscriptionProductScopeInfo> {
    const res = await this.request('DELETE', `/subscriptions/scopes/${id}`)
    return res.data.scope
  },

  async getSubscriptionProductScopes (productId: number, table: TableQuery): Promise<PagedResults<SubscriptionProductScopeInfo>> {
    const res = await this.request('GET', `/subscriptions/products/${productId}/scopes`, { ...table })
    return res.data.scopes
  },

  async getSubscriptionPlans<T extends TableQuery | undefined> (filters: GetSubscriptionPlansFilters, table?: T): Promise<MaybePaged<SubscriptionPlanInfo, T>> {
    const res = await this.request('GET', '/subscriptions/plans', { ...filters, ...table })
    return res.data.plans
  },

  async checkAllSubscriptionPlanCaches (): Promise<SubscriptionPlanInfo[][]> {
    const res = await this.request('GET', '/subscriptions/plans/cache_check')
    return res.data.caches
  },

  async getSubscriptionPlansForProduct<T extends TableQuery | undefined> (productId: number, table?: T): Promise<MaybePaged<SubscriptionPlanInfo, T>> {
    const res = await this.request('GET', `/subscriptions/products/${productId}/plans`, { ...table })
    return res.data.plans
  },

  async addSubscriptionPlan (scopeId: number, data: AddSubscriptionPlanRequest): Promise<SubscriptionPlanInfo> {
    const res = await this.request('POST', `/subscriptions/scopes/${scopeId}/plans`, data)
    return res.data.plan
  },

  async getChildrenOfPlan (id: number): Promise<SubscriptionPlanInfo[]> {
    const res = await this.request('GET', `/subscriptions/plans/${id}/children`)
    return res.data.children
  },

  async updateSubscriptionPlan (id: number, data: EditSubscriptionPlanRequest): Promise<SubscriptionPlanInfo> {
    const res = await this.request('PATCH', `/subscriptions/plans/${id}`, data)
    return res.data.plan
  },

  async getSubscriptionActions (filters: GetSubscriptionPlanActionsFilters): Promise<SubscriptionActionInfo[]> {
    const res = await this.request('GET', '/subscriptions/plans/actions', filters)
    return res.data.actions
  },

  async addActionForPlan (id: number, action: AddPlanActionRequest): Promise<SubscriptionActionInfo> {
    const res = await this.request('POST', `/subscriptions/plans/${id}/actions`, action)
    return res.data.action
  },

  async getSubsForPlan (id: number, table: TableQuery): Promise<PagedResults<SubscriptionForPlan>> {
    const res = await this.request('GET', `/subscriptions/plans/${id}/subscriptions`, table)
    return res.data.subscriptions
  },

  async cancelSubscriptionPlanAction (id: string): Promise<boolean> {
    const res = await this.request('DELETE', `/subscriptions/plans/actions/${id}`)
    return res.data.success
  },

  async retryPlanAction (id: string): Promise<boolean> {
    const res = await this.request('POST', `/subscriptions/plans/actions/${id}/retry`)
    return res.data.success
  },

  async prepayMultiYearSubscription (data: MakeSubscriptionPrepaymentRequest): Promise<MakeSubscriptionPrepaymentResponse> {
    const res = await this.request('POST', '/users/me/school/subscriptions/prepayment', data)
    return res.data
  },

  async cancelPrepaymentInvoice (actionSecret: string): Promise<boolean> {
    const res = await this.request('DELETE', '/subscriptions/prepayment/invoices', { action_secret: actionSecret })
    return res.data.success
  },

  async startPrepaidSubscription (data: StartPrepaidSubscriptionRequest): Promise<StartPrepaidSubscriptionResponse> {
    const res = await this.request('POST', '/users/me/school/subscriptions/prepayment/activation', data)
    return res.data
  },

  async prepayMultiYearUpgrade (subscriptionId: number, data: UpgradeSubscriptionRequest): Promise<MakeSubscriptionPrepaymentResponse> {
    const res = await this.request('POST', `/users/me/school/subscriptions/${subscriptionId}/upgrade/prepayment`, data)
    return res.data
  },

  async cancelMultiYearUpgradeInvoice (subscriptionId: number, actionSecret: string): Promise<boolean> {
    const res = await this.request('DELETE', `/subscriptions/${subscriptionId}/upgrade/prepayment`, { action_secret: actionSecret })
    return res.data.success
  },

  async applyMultiYearUpgrade (subscriptionId: number, actionSecret: string): Promise<StartPrepaidSubscriptionResponse> {
    const res = await this.request('POST', `/users/me/school/subscriptions/${subscriptionId}/upgrade/prepayment/activation`, { action_secret: actionSecret })
    return res.data
  },

  async startSubscription (data: StartSubscriptionRequest): Promise<StartSubscriptionResponse> {
    const res = await this.request('POST', '/users/me/school/subscriptions', data)
    return res.data
  },

  async startTrial (data: StartTrialRequest): Promise<UserModel> {
    const res = await this.request('POST', '/users/me/school/subscriptions/free', data)
    return res.data.user
  },

  async cancelSchoolSubscriptionAtExpiry (stripeId: string, params: CancelSubRequest): Promise<CancelSubscriptionResponse> {
    const res = await this.request('POST', `/users/me/school/subscriptions/${stripeId}/cancel`, params)
    return res.data
  },

  async uncancelSchoolSubscriptionAtExpiry (stripeId: string): Promise<Subscription> {
    const res = await this.request('DELETE', `/users/me/school/subscriptions/${stripeId}/cancel`)
    return res.data.subscription
  },
  // #endregion

  // #region processing jobs
  async checkProcessingJob (queueId: string, jobId: number | string): Promise<number> {
    const res = await this.request('GET', '/jobs', { queueId, jobId })
    return res.data.progress
  },
  async checkProcessingNameSpace (queueId: string, namespace_id: number | string): Promise<boolean> {
    const res = await this.request('GET', '/jobs/namespace', { queueId, namespace_id })
    return res.data.success
  },
  // #endregion

  // #region emails
  async sendEmail (emailId: number): Promise<string | number> {
    const res = await this.request('PUT', `/email/${emailId}/send`)
    return res.data.job_id
  },

  async getEmailStats (emailIds: number[]): Promise<{ [key in number]: MailgunStats }> {
    const res = await this.request('GET', '/email/stats', { ids: emailIds })
    return res.data.stats
  },
  // #endregion

  // #region letter tile tool
  async saveLetterTileToolState (data: TileToolState): Promise<string> {
    const res = await this.request('POST', '/lettertiles', data)
    return res.data.url
  },

  async getLetterTileToolState (ident: string): Promise<TileToolState> {
    const res = await this.request('GET', `/lettertiles/${ident}`)
    return res.data.state
  },
  // #endregion

  // #region xero
  async getXeroContacts (region: StripeInvoiceAccountRegion, filters: GetXeroContactsRequest): Promise<XeroContactInfo[]> {
    const res = await this.request('GET', `/superuser/xero/${region}/contacts`, filters)
    return res.data.contacts
  },
  // #endregion

  // #region grammar arcade
  async getReportedGrammarQuestions (tableQuery: TableQuery): Promise<PagedResults<ReportedGrammarQuestionInfo>> {
    const res = await this.request('GET', '/grammar/questions/reported', tableQuery)
    return res.data
  },
  async getGrammarCurriculumNodes (locale: Locale): Promise<GrammarStage[]> {
    const res = await this.request('GET', `/grammar/stages/${locale}`)
    return res.data
  },
  async getGrammarQuestions (gameIdent: GrammarGameIdent, lessonId: number | undefined, tableQuery: TableQuery): Promise<PagedResults<GrammarGameQuestionInfo>> {
    const res = await this.request('GET', '/grammar/questions', { gameIdent, lessonId, ...tableQuery })
    return res.data
  },
  async getGrammarQuestion (questionId: number): Promise<GrammarGameQuestionInfo> {
    const res = await this.request('GET', `/grammar/questions/${questionId}`)
    return res.data
  },
  async createGrammarQuestion (payload: GrammarGameQuestionCreateRequest): Promise<GrammarGameQuestionInfo> {
    const res = await this.request('POST', '/grammar/questions', payload)
    return res.data
  },
  async editGrammarQuestion (payload: GrammarGameQuestionEditRequest): Promise<GrammarGameQuestionInfo> {
    const res = await this.request('PUT', '/grammar/questions/edit', payload)
    return res.data
  },
  async setNodeIdForMultipleGrammarQuestions (new_node_id: number, question_ids: number[]): Promise<boolean> {
    const res = await this.request('PATCH', '/grammar/questions/multi_update_node_id', { new_node_id, question_ids })
    return res.data.success
  },
  async deleteGrammarQuestion (id: number): Promise<boolean> {
    const res = await this.request('DELETE', `/grammar/questions/${id}`)
    return res.data.success
  },
  async getQuestionsForGrammarGame (options: GrammarGameQuestionRequest): Promise<GrammarGameQuestionInfo[]> {
    const res = await this.request('GET', '/grammar/game/questions', options)
    return res.data
  },
  async saveGrammarGameSession (options: GrammarGameSessionCreate): Promise<{ session: GrammarGameSessionInfo, user: UserModel }> {
    const res = await this.request('POST', '/grammar/game/session', options)
    return res.data
  },
  async getGrammarGameSession (id: number): Promise<GrammarGameSessionInfo> {
    const res = await this.request('GET', `/grammar/game/session/${id}`)
    return res.data
  },
  async getGrammarGameSessionsForUser (tableQuery: TableQuery, filters: GrammarGameSessionFilters): Promise<PagedResults<GrammarGameSessionInfo>> {
    const res = await this.request('GET', '/grammar/game/sessions', { ...tableQuery, ...filters })
    return res.data
  },
  async getGrammarGameResponsesForUser (user_id: number, node_id: number): Promise<GrammarGameResponsesForUser> {
    const res = await this.request('GET', `/grammar/game/responses/user/${user_id}`, { node_id })
    return res.data
  },
  async getGrammarGameResponsesForGroup (group_id: number, node_id: number): Promise<GrammarGameResponsesForGroup> {
    const res = await this.request('GET', `/grammar/game/responses/group/${group_id}`, { node_id })
    return res.data
  },
  async reportGrammarQuestion (question_id: number, report: GrammarQuestionReport): Promise<boolean> {
    const res = await this.request('POST', `/grammar/questions/${question_id}/report`, report)
    return res.data.success
  },

  // grammar nodes admin
  async getNodesForLinking (educational_region: GrammarArcadeEducationalRegion): Promise<GrammarNodesForLinking> {
    const res = await this.request('GET', '/grammar/nodes_for_linking', { educational_region })
    return res.data
  },
  async linkGrammarLessonToQuizCurriculumNode (lesson_id: number, quiz_curriculum_node_id: number): Promise<boolean> {
    const res = await this.request('POST', '/grammar/link_lesson_to_curriculum_node', { lesson_id, quiz_curriculum_node_id })
    return res.data.success
  },
  async createGrammarLesson (data: CreateGrammarLessonRequest): Promise<GrammarLessonInfo> {
    const res = await this.request('POST', '/grammar/lessons', data)
    return res.data.lesson
  },
  async updateGrammarLesson (id: number, data: UpdateGrammarLessonRequest): Promise<boolean> {
    const res = await this.request('PUT', `/grammar/lessons/${id}`, data)
    return res.data.success
  },
  async createGrammarTopic (data: CreateGrammarTopicRequest): Promise<GrammarTopicInfo> {
    const res = await this.request('POST', '/grammar/topics', data)
    return res.data.topic
  },
  async updateGrammarTopic (id: number, data: UpdateGrammarTopicRequest): Promise<boolean> {
    const res = await this.request('PUT', `/grammar/topics/${id}`, data)
    return res.data.success
  },
  async deleteGrammarLesson (id: number): Promise<boolean> {
    const res = await this.request('DELETE', `/grammar/lessons/${id}`)
    return res.data.success
  },
  // #endregion

  // #region champions
  async getChampionUsers (tableQuery: TableQuery, filters: ChampionFilters): Promise<PagedResults<ChampionModel>> {
    const res = await this.request('GET', '/users/champions', { ...tableQuery, ...filters })
    return res.data.users
  },
  // #endregion

  // #region addresses
  async createAddress (address: AddressToAdd, addressType: AddressType | null): Promise<AddressInfo> {
    const res = await this.request('POST', '/addresses', { address, addressType })
    return res.data.address
  },

  async changeDefaultAddress (schoolId: number, addressId: number, type: AddressType): Promise<SchoolModel> {
    const res = await this.request('PUT', `schools/${schoolId}/addresses/${type}`, { addressId })
    return res.data.school
  },

  async deleteAddress (id: number): Promise<{ success: boolean }> {
    const res = await this.request('DELETE', `/addresses/delete/${id}`)
    return res.data.success
  },

  async editAddress (id: number, address: AddressToEdit, addressType: AddressType | null, schoolId?: number): Promise<AddressInfo> {
    const res = await this.request('PUT', `/addresses/${id}`, { address, addressType, schoolId })
    return res.data.address
  },

  async getMySchoolAddresses (tableQuery: TableQuery | undefined): Promise<PagedResults<AddressInfo>> {
    const res = await this.request('GET', '/users/me/school/addresses', { ...tableQuery })
    return res.data.addresses
  },

  // #endregion

  // #region avatar
  async getDebugAvatar (): Promise<string> {
    const res = await this.request('GET', '/avatars/debug')
    return res.data
  },
  async generateAvatarImage (userId: number): Promise<{ base64: string, hash: string }> {
    const res = await this.request('POST', `users/${userId}/avatar`)
    return res.data
  },
  async browseAvatarItems (tableQuery: TableQuery, type?: AvatarItemSlot): Promise<PagedResults<AvatarItemInfo>> {
    const res = await this.request('GET', '/avatars/items/browse', { ...tableQuery, type })
    return res.data.items
  },
  async createAvatarItem (item: AvatarItemCreateRequest): Promise<AvatarItemInfo> {
    const res = await this.request('POST', '/avatars/items', item)
    return res.data.item
  },
  async editAvatarItem (ident: string, item: AvatarItemEditRequest): Promise<AvatarItemInfo> {
    const res = await this.request('PUT', `/avatars/items/${ident}`, item)
    return res.data.item
  },
  async getAvatarItems (idents: string[]): Promise<AvatarItemInfo[]> {
    const res = await this.request('GET', '/avatars/items', { idents })
    return res.data.items
  },
  async getAvatarItem (ident: string): Promise<AvatarItemInfo> {
    const res = await this.request('GET', `/avatars/items/${ident}`)
    return res.data.item
  },
  async removeAvatarItem (ident: string): Promise<AvatarItemInfo> {
    const res = await this.request('DELETE', `/avatars/items/${ident}`)
    return res.data.item
  },
  async updateAvatarItemSortOrder (ident: string, sortOrder: number): Promise<AvatarItemInfo> {
    const res = await this.request('PATCH', `/avatars/items/${ident}/sort_order`, { sortOrder })
    return res.data.item
  },
  async getUserAvatarInfo (id: number): Promise<UserAvatar> {
    const res = await this.request('GET', `users/${id}/avatar`)
    return res.data.avatar
  },
  // #region reported
  async removeFlag (report: ReportedQuestionInfo | ReportedLessonInfo): Promise<boolean> {
    const res = await this.request('POST', '/reported/flag', { report })
    return res.data.success
  },
  // #endregion
  // #region feedback
  async createFeedback (options: CreateFeedbackOptions): Promise<{ success: boolean }> {
    const res = await this.request('POST', '/feedback', options)
    return res.data
  },
  async getFeedbackById<TIncludeUser extends boolean> (id: number, includeUser?: TIncludeUser): Promise<FeedbackItem<TIncludeUser>> {
    const res = await this.request('GET', `/feedback/${id}`, { includeUser })
    return res.data
  },
  async getFeedbacks<TIncludeUser extends boolean> (filters: FeedbackQueryOptions, table: TableQuery, includeUser?: TIncludeUser): Promise<PagedResults<FeedbackItem<TIncludeUser>>> {
    const res = await this.request('GET', '/feedback', { includeUser, ...table, ...filters })
    return res.data
  },
  async deleteFeedback (id: number): Promise<boolean> {
    const res = await this.request('DELETE', `/feedback/${id}`)
    return res.data.success
  },
  // #endregion
  async stripeWebhook (): Promise<boolean> {
    const res = await this.request('POST', '/stripe')
    return res.data.received
  }
}
